/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/_build/webpack_bundles/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 755);
/******/ })
/************************************************************************/
/******/ ({

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URLs = function () {
    function URLs() {
        _classCallCheck(this, URLs);

        this.urls = {
            'create': this._create,
            'forgot_password': null,
            'gallery': this._gallery,
            'gallery/category': function galleryCategory(data) {
                return '/gallery/category/' + data.category + '/';
            },
            'ajax_gallery_suggestions': function ajax_gallery_suggestions(data) {
                return '/ajax/gallery/suggestions/' + data.search + '/';
            },
            'ajax_gallery_category': function ajax_gallery_category(data) {
                return '/ajax/gallery/' + data.category + '/';
            },
            'ajax_gallery_category_featured': function ajax_gallery_category_featured(data) {
                return '/ajax/gallery/' + data.category + '/featured/';
            },
            'ajax_event_settings': function ajax_event_settings(data) {
                return '/ajax/event/' + data.event_id + '/view/settings/';
            },
            'ajax_event_guestlist': function ajax_event_guestlist(data) {
                return '/ajax/event/' + data.event_id + '/guestlist/?gid=' + data.gid;
            },
            'ajax_event_avatars': function ajax_event_avatars(data) {
                return '/ajax/event/' + data.event_id + '/guestlist/avatars/?gid=' + data.gid;
            },
            'ajax_edit_guest_tags': function ajax_edit_guest_tags(data) {
                return '/ajax/event/' + data.event_id + '/posts/' + data.post_id + '/tags/?gid=' + data.gid;
            },
            'ajax_render_event_image': function ajax_render_event_image(data) {
                return '/ajax/event/' + data.event_id + '/renderimage/';
            },
            'ajax_event_posts': function ajax_event_posts(data) {
                return '/ajax/event/' + data.event_id + '/posts/?cursor=' + (data.cursor || '') + '&gid=' + data.gid;
            },
            'ajax_event_photos': function ajax_event_photos(data) {
                return '/ajax/event/' + data.event_id + '/posts/photos/?per_page=' + (data.per_page || 10) + '&cursor=' + (data.cursor || '') + '&gid=' + data.gid;
            },
            'ajax_event_guestlist_search': function ajax_event_guestlist_search(data) {
                return '/ajax/event/' + data.event_id + '/guestlist/search/?q=' + data.search_term + '&gid=' + data.gid;
            },
            'login': '/login/',
            'login_modal': '/login_modal/',
            'recaptcha': '/modal/recaptcha/',
            'sms_captcha': '/modal/sms_captcha/',
            'ad_captcha': '/modal/ad_captcha/',
            'modal_dialog': '/modal/dialog',
            'modal_warning': '/modal/warning',
            'modal_loading': '/modal/loading',
            'modal_ajax_error': '/modal/ajax_error/',
            'import_contacts': '/profile/contacts/import/',
            'ajax_user_status': '/ajax/settings/account/status/',
            'modal_merge_registered': '/modal/settings/account/merge/registered/',
            'modal_merge_secondary': '/modal/settings/account/merge/secondary/',
            'ajax_merge_registered': '/ajax/settings/account/merge/registered/',
            'modal_contacts_edit': '/modal/profile/contacts/edit',
            'modal_contacts_new': '/modal/profile/contacts/new',
            'modal_contacts_groups_edit': '/modal/profile/contacts/groups/edit',
            'modal_contacts_groups_new': '/modal/profile/contacts/groups/new',
            'modal_contacts_add__select_group': '/modal/profile/contacts/groups/select',
            'modal_contacts_add__list': '/modal/profile/contacts/groups/list',
            'modal_recurring_event': '/modal/event/recurring_event/',
            'ajax_event_schedule': function ajax_event_schedule(data) {
                return '/ajax/event/recurring_event/' + data.event_id + '/';
            },
            'ajax_cancel_one_recurring': function ajax_cancel_one_recurring(data) {
                return '/ajax/event/cancel_one_recurring/' + data.event_id + '/';
            },
            'ajax_cancel_all_recurring': function ajax_cancel_all_recurring(data) {
                return '/ajax/event/cancel_all_recurring/' + data.event_id + '/';
            },
            'modal_edit_one_recurring': function modal_edit_one_recurring(data) {
                return '/modal/event/edit_one_recurring/' + data.event_id + '/' + data.old_date + '/';
            },
            'ajax_edit_one_recurring': function ajax_edit_one_recurring(data) {
                return '/ajax/event/edit_one_recurring/' + data.event_id + '/';
            },
            'profile_events': '/profile/events/',
            'more_past_events': '/profile/events/past/more/',
            'ajax_remove_inbox_event': '/ajax/profile/events/remove/',
            'ajax_send_verify_email': '/profile/send_verify_email/',
            'modal_notification_prefs': '/modal/profile/notification/',
            'ajax_profile_contacts': '/ajax/profile/contacts/',
            'ajax_profile_multiple_contacts': '/ajax/profile/contacts/multiple/',
            'ajax_delete_multiple_contacts': '/ajax/profile/contacts/multiple/delete/',
            'ajax_profile_contacts_groups': '/ajax/profile/groups/',
            'ajax_contacts_groups__add_contacts': function ajax_contacts_groups__add_contacts(data) {
                return '/ajax/profile/groups/' + data.group_id + '/add_contacts/';
            },
            'ajax_contacts_groups__remove_contact': function ajax_contacts_groups__remove_contact(data) {
                return '/ajax/profile/groups/' + data.group_id + '/remove/' + data.contact_id + '/';
            },
            'ajax_remove_photo': '/ajax/profile/remove_photo/',
            'register': '/register/',
            'register_modal': '/modal/register/',
            'forgot_modal': '/modal/forgot/',
            'forgot_mobile': '/mobile/forgot/',
            'cstool_set_spam': function cstool_set_spam(data) {
                return '/cstool/set_spam/' + data.event_id + '/' + data.status + '/' + data.task_name + '/';
            },
            'cstool_edit_admin_user': '/cstool/admin/users/edit/',
            'cstool_edit_admin_device_versions': '/cstool/admin/device-versions/edit/',
            'cstool_edit_phone_optout': '/cstool/admin/phone_optout/edit/',
            'cstool_experiments_set_variation': '/cstool/admin/experiments/set-variation-winner/',
            'cstool_spam_mark_as_seen': '/cstool/spam/event/mark_as_seen/',
            'cstool_spam_events': '/cstool/spam/events/',
            'cstool_event_actions': '/cstool/events/ajax_actions/',
            'cstool_user_actions': '/cstool/users/ajax_actions/',
            'cstool_event': '/cstool/events/event/',
            'view': function view(data) {
                return '/event/' + data.event_id + '/';
            },
            'send_message_modal': function send_message_modal(data) {
                return '/event/' + data.event_id + '/view/send_message_modal/';
            },
            'send_sms_modal': function send_sms_modal(data) {
                return '/event/' + data.event_id + '/view/send_sms_modal/';
            },
            'ajax_view_profiles': function ajax_view_profiles(data) {
                return '/ajax/event/' + data.event_id + '/view/profiles/';
            },
            'ajax_view_rsvp': function ajax_view_rsvp(data) {
                return '/ajax/event/' + data.event_id + '/view/rsvp/';
            },
            'modal_knot_link_registry': '/modal/event/link_registry/',
            'modal_knot_find_registry': '/modal/event/find_registry/',
            'ajax_logout': '/ajax_logout',
            'ajax_knot_search': '/ajax/knot_search/',
            'ajax_request_upload_path': '/ajax/upload/prepare',
            'ajax_fetchuyo': '/ajax/images/fetchuyo',
            'ajax_crop_image': function ajax_crop_image(data) {
                return '/ajax/images/' + data.image_id + '/crop';
            },
            'ajax_content_feed': function ajax_content_feed(data) {
                return '/ajax/content/feed/' + data.event_type;
            },
            'main_image': function main_image(data) {
                return '/services/images/' + data.image_id + '/main';
            },
            'large_image': function large_image(data) {
                return '/services/images/' + data.image_id + '/large';
            },
            'image_url': function image_url(data) {
                return '/services/image_url/' + data.image_id + '/' + data.size;
            },
            'ajax_comments': function ajax_comments(data) {
                return '/ajax/event/comments/' + data.event_id + '/' + window.guest_id + '/';
            },
            'modal_add_to_calendar': function modal_add_to_calendar(data) {
                return '/modal/event/' + data.event_id + '/add_to_calendar/';
            },
            'invite_more': this._invite_more,
            'send': '/event/send/',
            'cancel': '/event/cancel/',
            'whatsnext': function whatsnext(data) {
                return '/whatsnext/' + data.event_id + '/';
            },
            'edit': function edit(data) {
                return '/event/' + data.event_id + '/edit/';
            },
            'upload_guest_csv': function upload_guest_csv(data) {
                return '/event/' + data.event_id + '/guests/csv/';
            },
            'ajax_guestlist': function ajax_guestlist(data) {
                return '/ajax/event/' + data.event_id + '/dashboard/guestlist/';
            },
            'event_dashboard': function event_dashboard(data) {
                return '/event/' + data.event_id + '/dashboard/';
            },
            'parse_guest': '/ajax/event/parse_guests/',
            'guest_list_save': function guest_list_save(data) {
                return '/ajax/event/' + data.event_id + '/replace_guests/';
            },
            'guest_list_add': function guest_list_add(data) {
                return '/ajax/event/' + data.event_id + '/add_guests/';
            },
            'frp_updated': function frp_updated(data) {
                return '/event/' + data.event_id + '/frp/updated/';
            },
            'frp_message_sent': function frp_message_sent(data) {
                return '/event/' + data.event_id + '/frp/message_sent/';
            },
            'frp_sent': function frp_sent(data) {
                return '/event/' + data.event_id + '/frp/sent/';
            },
            'frp_saved': function frp_saved(data) {
                return '/event/' + data.event_id + '/frp/saved/';
            },
            'frp_canceled': function frp_canceled(data) {
                return '/event/' + data.event_id + '/frp/canceled/';
            },
            'ajax_preview': '/event/preview/',
            'ajax_authenticated': '/ajax/authenticated/',
            'facebook_connect': '/services/extdata/oa2/login/facebook/login/',
            'google_plus_connect': '/services/extdata/oa2/login/google_plus/login/',
            'set_draft_guests': '/ajax/set_draft_guests/',
            'csv_import_contacts': '/profile/contacts/import/csv/',
            'ajax_subscribe': '/ajax/subscribe/',
            'ajax_send_sms': function ajax_send_sms(data) {
                return '/ajax/event/' + data.event_id + '/send_sms/';
            },
            'event_map': function event_map(data) {
                return '/event/' + data.event_id + '/map?gid=' + data.guest_id;
            },
            'event_map_redirect': function event_map_redirect(data) {
                return '/event/' + data.event_id + '/map_redirect?gid=' + data.guest_id;
            },
            'print_event': function print_event(data) {
                return '/event/' + data.event_id + '/export/print';
            },
            'print_event_premium': function print_event_premium(data) {
                return '/plus/view/' + data.event_id + '/' + data.guest_id + '/print_invitation/?';
            },
            'jifiti_url_redirect': function jifiti_url_redirect(data) {
                return '/event/' + data.event_id + '/jifiti_url/?guest_id=' + data.guest_id;
            },
            'ajax_notify_items': '/ajax/notify/items',
            'ajax_notify_update': '/ajax/notify/update',
            'all_notifications': '/all-notifications'
        };
    }

    _createClass(URLs, [{
        key: 'get',
        value: function get(name, params) {
            var url = this.urls[name];
            if (!url) {
                throw Error('URL ' + name + ' is not mapped');
            }
            if (typeof url === 'function') {
                var escaped = {};
                if (params) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.keys(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var k = _step.value;

                            var v = params[k];
                            escaped[k] = encodeURIComponent(v);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                url = url(escaped);
            }

            return url;
        }
    }, {
        key: '_invite_more',
        value: function _invite_more(params) {
            var event_id = params.eid || params.event_id || window.event_id;
            var p = {
                guest_id: params.gid || window.guest_id
            };
            var param_str = $.param(p);
            return '/event/' + event_id + '/invite_more/?' + param_str;
        }
    }, {
        key: '_create',
        value: function _create(params) {
            var p = {
                template: params.template,
                event_type: params.event_type || params.eventType
            };
            var param_str = $.param(p);
            return '/event/create/?' + param_str;
        }
    }, {
        key: '_profile',
        value: function _profile(params) {
            if (params && params.uid) {
                return '/profile/public/' + params.uid + '/';
            }
            return "/profile/";
        }
    }, {
        key: '_profile_private',
        value: function _profile_private(params) {
            if (params.section) {
                if (params.section === 'events') {
                    if (params.tab === 'upcoming') {
                        return this.get('profile_events');
                    }
                    if (params.tab === 'past') {
                        return this.get('profile_past_events');
                    }
                }
                if (params.section === 'contacts') {
                    return this.get('profile_contacts');
                }
            }

            return this.get('profile_edit');
        }
    }, {
        key: '_account_validate',
        value: function _account_validate(params) {
            var k, p, url, v;
            url = this.get('verify_email');
            p = [];
            for (k in params) {
                v = params[k];
                p.push(k + "=" + v);
            }
            return url + '?' + p.join('&');
        }
    }, {
        key: '_reset_password',
        value: function _reset_password(params) {
            return this.get('reset_password') + ("?token=" + params.chk);
        }
    }, {
        key: '_gallery',
        value: function _gallery(params) {
            if (params) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = Object.keys(params)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var k = _step2.value;

                        var v = params[k];
                        params[k] = unescape(v);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var param_str = $.param(params);
            return '/gallery/?' + param_str;
        }
    }]);

    return URLs;
}();

;

var LegacyURL = exports.LegacyURL = function () {
    function LegacyURL(name1, params) {
        _classCallCheck(this, LegacyURL);

        this.name = name1;
        this.params = params || {};
        return this;
    }

    _createClass(LegacyURL, [{
        key: 'add_param',
        value: function add_param(key, value) {
            this.params[key] = value;
        }
    }]);

    return LegacyURL;
}();

;

var LegacyRouter = exports.LegacyRouter = function () {
    function LegacyRouter() {
        _classCallCheck(this, LegacyRouter);
    }

    _createClass(LegacyRouter, [{
        key: 'parse',
        value: function parse(hash) {
            if (hash.match(/^#/)) {
                hash = hash.substring(1);
            }

            // parse the old hash location and return a LegacyURL instance
            var parts = hash.split(':');
            if (parts.length < 1) {
                return;
            }

            var url = new LegacyURL(parts[0]);

            if (parts.length > 1) {
                url = this.add_params(url, parts[1]);
            }
            return url;
        }
    }, {
        key: 'add_params',
        value: function add_params(url, param_str) {
            var pairs = param_str.split('&');
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = pairs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var pair = _step3.value;

                    var key_value = pair.split('=');
                    if (key_value.length > 1) {
                        url.add_param(key_value[0], key_value[1]);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return url;
        }
    }, {
        key: 'to_typhoon',
        value: function to_typhoon(url) {
            return urls.get(url.name, url.params);
        }
    }], [{
        key: 'check_hash',
        value: function check_hash() {
            var hash = window.location.hash;
            if (hash) {
                var router = new LegacyRouter();
                var url = router.parse(hash);
                var href = window.location.href;
                var left = href.indexOf('?');
                if (left !== -1) {
                    var right = href.indexOf('#');
                    if (right !== -1) {
                        router.add_params(url, href.slice(left + 1, right));
                    }
                }

                var new_path = void 0;
                try {
                    new_path = router.to_typhoon(url);
                } catch (error) {
                    if (window.console != null && console.log != null) {
                        // console.log(`hash change not translated to typhoon: ${e}`);
                    }
                }
                if (new_path) {
                    if (window.LoadingModal != null) {
                        var loading_modal = new LoadingModal();
                        loading_modal.show('Loading...');
                    }
                    try {
                        tags.track_event('legacy-url');
                    } catch (e) {}
                    window.location.replace(new_path);
                    return true;
                }
                return false;
            }
        }
    }]);

    return LegacyRouter;
}();

;

var root;
if (typeof window !== "undefined" && window !== null) {
    root = window;
} else {
    root = eval('global');
}

root.urls = new URLs();
root.LegacyURL = LegacyURL;
root.LegacyRouter = LegacyRouter;

exports.default = root.urls;


evite.resolvePromiseByName('common/urls', root.urls);

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

/*! store2 - v2.5.1 - 2017-03-28
* Copyright (c) 2017 Nathan Bubna; Licensed ,  */
;(function(window, define) {
    var _ = {
        version: "2.5.1",
        areas: {},
        apis: {},

        // utilities
        inherit: function(api, o) {
            for (var p in api) {
                if (!o.hasOwnProperty(p)) {
                    o[p] = api[p];
                }
            }
            return o;
        },
        stringify: function(d) {
            return d === undefined || typeof d === "function" ? d+'' : JSON.stringify(d);
        },
        parse: function(s) {
            // if it doesn't parse, return as is
            try{ return JSON.parse(s); }catch(e){ return s; }
        },

        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for (var api in _.apis) {
                _.apis[api][name] = fn;
            }
        },
        get: function(area, key){ return area.getItem(key); },
        set: function(area, key, string){ area.setItem(key, string); },
        remove: function(area, key){ area.removeItem(key); },
        key: function(area, i){ return area.key(i); },
        length: function(area){ return area.length; },
        clear: function(area){ area.clear(); },

        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0){ return store.getAll(); }
                if (typeof data === "function"){ return store.transact(key, data, overwrite); }// fn=data, alt=overwrite
                if (data !== undefined){ return store.set(key, data, overwrite); }
                if (typeof key === "string" || typeof key === "number"){ return store.get(key); }
                if (!key){ return store.clear(); }
                return store.setAll(key, data);// overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '_safariPrivate_';
                area.setItem(testKey, 'sucks');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {}
            if (!store._area) {
                store._area = _.inherit(_.storageAPI, { items: {}, name: 'fake' });
            }
            store._ns = namespace || '';
            if (!_.areas[id]) {
                _.areas[id] = store._area;
            }
            if (!_.apis[store._ns+store._id]) {
                _.apis[store._ns+store._id] = store;
            }
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns);//new area-specific api in this namespace
                    if (!this[id]){ this[id] = store; }
                }
                return store;
            },
            namespace: function(namespace, noSession) {
                if (!namespace){
                    return this._ns ? this._ns.substring(0,this._ns.length-1) : '';
                }
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns+ns+'.');//new namespaced api
                    if (!this[ns]){ this[ns] = store; }
                    if (!noSession){ store.area('session', _.areas.session); }
                }
                return store;
            },
            isFake: function(){ return this._area.name === 'fake'; },
            toString: function() {
                return 'store'+(this._ns?'.'+this.namespace():'')+'['+this._id+']';
            },

            // storage functions
            has: function(key) {
                if (this._area.has) {
                    return this._area.has(this._in(key));//extension hook
                }
                return !!(this._in(key) in this._area);
            },
            size: function(){ return this.keys().length; },
            each: function(fn, and) {
                for (var i=0, m=_.length(this._area); i<m; i++) {
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, and || this.get(key)) === false) {
                            break;
                        }
                    }
                    if (m > _.length(this._area)) { m--; i--; }// in case of removeItem
                }
                return and || this;
            },
            keys: function() {
                return this.each(function(k, list){ list.push(k); }, []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key));
                return s !== null ? _.parse(s) : alt || s;// support alt for easy default mgmt
            },
            getAll: function() {
                return this.each(function(k, all){ all[k] = this.get(k); }, {});
            },
            transact: function(key, fn, alt) {
                var val = this.get(key, alt),
                    ret = fn(val);
                this.set(key, ret === undefined ? val : ret);
                return this;
            },
            set: function(key, data, overwrite) {
                var d = this.get(key);
                if (d != null && overwrite === false) {
                    return data;
                }
                return _.set(this._area, this._in(key), _.stringify(data), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for (var key in data) {
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) {
                        changed = true;
                    }
                }
                return changed;
            },
            remove: function(key) {
                var d = this.get(key);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) {
                    _.clear(this._area);
                } else {
                    this.each(function(k){ _.remove(this._area, this._in(k)); }, 1);
                }
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for (var id in _.areas) {
                    if (_.areas.hasOwnProperty(id)) {
                        this._area = _.areas[id];
                        this.clear();
                    }
                }
                this._area = area;
                return this;
            },

            // internal use functions
            _in: function(k) {
                if (typeof k !== "string"){ k = _.stringify(k); }
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ?
                    k && k.indexOf(this._ns) === 0 ?
                        k.substring(this._ns.length) :
                        undefined : // so each() knows to skip it
                    k;
            }
        },// end _.storeAPI
        storageAPI: {
            length: 0,
            has: function(k){ return this.items.hasOwnProperty(k); },
            key: function(i) {
                var c = 0;
                for (var k in this.items){
                    if (this.has(k) && i === c++) {
                        return k;
                    }
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) {
                    this.length++;
                }
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k){ return this.has(k) ? this.items[k] : null; },
            clear: function(){ for (var k in this.list){ this.removeItem(k); } },
            toString: function(){ return this.length+' items in '+this.name+'Storage'; }
        }// end _.storageAPI
    };

    var store =
        // safely set this up (throws error in IE10/32bit mode for local files)
        _.Store("local", (function(){try{ return localStorage; }catch(e){}})());
    store.local = store;// for completeness
    store._ = _;// for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", (function(){try{ return sessionStorage; }catch(e){}})());

    if (typeof define === 'function' && define.amd !== undefined) {
        define('store2', [], function () {
            return store;
        });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = store;
    } else {
        // expose the primary store fn to the global object and save conflicts
        if (window.store){ _.conflict = window.store; }
        window.store = store;
    }

})(this, this.define);


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(store) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ajax_csrf_setup = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax_csrf_setup = __webpack_require__(244);

var _registerLogin = __webpack_require__(243);

var _registerLogin2 = _interopRequireDefault(_registerLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderNavView = function (_Backbone$View) {
    _inherits(HeaderNavView, _Backbone$View);

    function HeaderNavView() {
        _classCallCheck(this, HeaderNavView);

        return _possibleConstructorReturn(this, (HeaderNavView.__proto__ || Object.getPrototypeOf(HeaderNavView)).apply(this, arguments));
    }

    _createClass(HeaderNavView, [{
        key: 'account_menu_toggle',
        value: function account_menu_toggle(e) {
            e.stopPropagation();

            if ($('#account .menu.menu_expanded').length === 0) {
                $('#account .menu').show();
                $('#account .menu').addClass('menu_expanded');
            } else {
                var el = $('#account .menu');
                this.hide_menu(el);
            }
        }
    }, {
        key: 'run_search',
        value: function run_search(event) {
            event.target.closest('form').submit();
        }
    }, {
        key: 'hide_menu',
        value: function hide_menu(el) {
            if (el.length >= 1) {
                $(el).removeClass('menu_expanded');
            } else {
                $('#account .menu').removeClass('menu_expanded');
            }
        }
    }, {
        key: 'site_warning',
        value: function site_warning(message) {
            $('<div></div>').addClass('site-warning').html(message).prependTo($('#header'));
        }
    }, {
        key: 'is_alt',
        value: function is_alt() {
            // returns true if the header is in the alt-header state used for the create flow
            this.$el.hasClass('alt-header');
        }
    }, {
        key: 'el',
        get: function get() {
            return 'body';
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click #account .user': 'account_menu_toggle',
                'click #page': 'hide_menu',
                'touchstart #searchIcon': 'run_search',
                'click #searchIcon': 'run_search'
            };
        }
    }]);

    return HeaderNavView;
}(Backbone.View);

;

var SignInModel = function (_Backbone$Model) {
    _inherits(SignInModel, _Backbone$Model);

    function SignInModel() {
        _classCallCheck(this, SignInModel);

        return _possibleConstructorReturn(this, (SignInModel.__proto__ || Object.getPrototypeOf(SignInModel)).apply(this, arguments));
    }

    _createClass(SignInModel, [{
        key: 'defaults',
        get: function get() {
            return {
                user: null,
                signed_in: false
            };
        }
    }]);

    return SignInModel;
}(Backbone.Model);

;

var SignInView = function (_Backbone$View2) {
    _inherits(SignInView, _Backbone$View2);

    function SignInView() {
        _classCallCheck(this, SignInView);

        return _possibleConstructorReturn(this, (SignInView.__proto__ || Object.getPrototypeOf(SignInView)).apply(this, arguments));
    }

    _createClass(SignInView, [{
        key: 'initialize',
        value: function initialize() {
            window.sign_in_model.signed_in = this.check_signed_in();
        }
    }, {
        key: 'get_user',
        value: function get_user() {
            // evite_cookie = window.evite.cookie('x-evite-auth')
            // evite_cookie && evite_cookie.split(':')[0]
            // doh, the auth cookie changed and we need some way to keep this functionality
            return window.tags.dl.email;
        }
    }, {
        key: 'check_signed_in',
        value: function check_signed_in() {
            var r = 0;
            try {
                r = window.tags.dl.is_logged_in === 1;
            } finally {
                return r;
            }
        }
    }, {
        key: 'get_next',
        value: function get_next() {
            // for sign in and register, return the 'next' param if appropriate
            if (window.location.protocol === 'https:') {
                return getURLParameter('next');
            }

            if (!window.location.pathname.match(/(login|register).*/)) {
                var n = window.location.pathname;
                if (window.location.search) {
                    n += window.location.search;
                }
                return n;
            }
            return null;
        }
    }, {
        key: 'sign_in',
        value: function sign_in(callback, next) {
            var _this4 = this;

            if (next == null) {
                next = null;
            }
            if (typeof callback !== 'function') {
                callback = null;
            }
            if (callback == null && !window.header_nav_view.is_alt()) {
                next = next || this.get_next() || '';
                if (next) {
                    next = '?next=' + encodeURIComponent(next);
                }
                window.location.href = urls.get('login') + next;
                return;
            }
            var sign_in_modal = new SecureModal({
                url: urls.get('login_modal'),
                onLogin: function onLogin(r) {
                    window.tags.track_event('on_login');
                    if (callback != null) {
                        _this4.set_signed_in_state(r.full_name);
                        return callback();
                    } else {
                        return _this4.set_signed_in(r.full_name);
                    }
                },
                onCancel: function onCancel() {
                    return $(_this4).trigger('cancel');
                }
            });
            return sign_in_modal.show();
        }
    }, {
        key: 'register',
        value: function register(callback, next) {
            var register_modal;
            if (next == null) {
                next = '';
            }
            if (typeof callback !== 'function') {
                callback = null;
            }
            if (callback == null && !window.header_nav_view.is_alt()) {
                next = next || this.get_next() || '';
                if (next) {
                    next = '?next=' + encodeURIComponent(next);
                }
                window.location.href = urls.get('register') + next;
                return;
            }
            register_modal = new SecureModal({
                url: urls.get('register_modal'),
                onLogin: function onLogin(d) {
                    return window.sign_in_view.set_signed_in(d.full_name);
                }
            });
            return register_modal.show();
        }
    }, {
        key: 'sign_out',
        value: function sign_out() {
            window.tags.page_event('signout_button');
            return $.ajax({
                type: 'POST',
                url: urls.get('ajax_logout')
            }).done(function (data) {
                return window.location.assign(urls.get('login'));
            });
        }
    }, {
        key: 'set_signed_in_state',
        value: function set_signed_in_state(full_name) {
            $('.logged_in').show();
            $('.signed_in').show();
            $('.logged_out').hide();
            $('.signed_out').hide();
            $('.signin').hide();
            window.sign_in_model.signed_in = true;
            window.sign_in_model.user = full_name;
            $('li.user .full_name').html(full_name);
            return $(this).trigger('success');
        }
    }, {
        key: 'set_signed_in',
        value: function set_signed_in(full_name) {
            if (!window.prevent_page_reload_on_login) {
                return window.location.reload();
            } else {
                return this.set_signed_in_state(full_name);
            }
        }
    }, {
        key: 'facebook_connect',
        value: function facebook_connect(opts) {
            var _this5 = this;

            window.tags.page_event('facebook_connect');

            var w = 580;
            var h = 400;
            var left = screen.width / 2 - w / 2;
            var top = screen.height / 2 - h / 2;
            var popup = window.open(urls.get('facebook_connect'), 'fb_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
            if (popup == null) {
                if (!window.prevent_page_reload_on_login) {
                    window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
                } else {
                    alert("We tried to open a popup window to connect to Facebook. Please enable popup windows in your browser.");
                }
                return;
            }

            var check_connected = function check_connected() {
                if (popup.closed) {
                    return $.ajax({
                        url: urls.get('ajax_authenticated'),
                        dataType: "json",
                        success: function success(data) {
                            if (data && data.full_name) {
                                _this5.set_signed_in(data.full_name);
                                if (opts.onConnect) {
                                    return opts.onConnect();
                                }
                            }
                        },
                        error: function error(xhr, status, _error) {
                            if (window.console != null) {
                                // console.log(`auth error: ${status}, error: ${error}, response: ${xhr.responseText}`);
                            }
                        }
                    });
                } else {
                    return setTimeout(check_connected, 300);
                }
            };

            return check_connected();
        }
    }, {
        key: 'google_plus_connect',
        value: function google_plus_connect(opts) {
            var _this6 = this;

            window.tags.page_event('google_plus_connect');

            var w = 580;
            var h = 400;
            var left = screen.width / 2 - w / 2;
            var top = screen.height / 2 - h / 2;
            var popup = window.open(urls.get('google_plus_connect'), 'gp_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
            if (popup == null) {
                if (!window.prevent_page_reload_on_login) {
                    window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
                } else {
                    alert("We tried to open a popup window to connect to Google Plus. Please enable popup windows in your browser.");
                }
                return;
            }

            var check_connected = function check_connected() {
                if (popup.closed) {
                    return $.ajax({
                        url: urls.get('ajax_authenticated'),
                        dataType: "json",
                        success: function success(data) {
                            if (data && data.full_name) {
                                _this6.set_signed_in(data.full_name);
                                if (opts.onConnect) {
                                    return opts.onConnect();
                                }
                            }
                        },
                        error: function error(xhr, status, _error2) {
                            if (window.console != null) {
                                // console.log(`auth error: ${status}, error: ${error}, response: ${xhr.responseText}`);
                            }
                        }
                    });
                } else {
                    return setTimeout(check_connected, 300);
                }
            };

            return check_connected();
        }
    }, {
        key: 'el',
        get: function get() {
            return '#header';
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click #signin_button': 'sign_in',
                'click #signout_button': 'sign_out',
                'click #register_button': 'register'
            };
        }
    }]);

    return SignInView;
}(Backbone.View);

;

var RegisterView = function (_Backbone$View3) {
    _inherits(RegisterView, _Backbone$View3);

    function RegisterView() {
        _classCallCheck(this, RegisterView);

        return _possibleConstructorReturn(this, (RegisterView.__proto__ || Object.getPrototypeOf(RegisterView)).apply(this, arguments));
    }

    _createClass(RegisterView, [{
        key: 'register',
        value: function register() {
            if ((typeof callback === "undefined" || callback === null) && !window.header_nav_view.is_alt()) {
                var next = '';
                if (window.location.protocol !== 'https' && !window.location.pathname.match(/(login|register).*/)) {
                    next = '?next=' + encodeURIComponent(window.location.pathname);
                }
                window.location.href = urls.get('register') + next;
                return;
            }

            var register_modal = new SecureModal({
                url: urls.get('register_modal'),
                // use Login to match SignInView - in case the user hits 'login' and chooses to register
                onLogin: function onLogin(d) {
                    return window.sign_in_view.set_signed_in(d.full_name);
                }
            });
            return register_modal.show();
        }
    }, {
        key: 'el',
        get: function get() {
            return 'div#header';
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click #register_button': 'register'
            };
        }
    }]);

    return RegisterView;
}(Backbone.View);

;

function card_height(class_name) {
    var height = 400;
    switch (class_name) {
        case 'panel':
            height = 475;
            break;
        case 'postcard':
            height = 555;
            break;
        case 'full':
            height = 555;
            break;
        case 'big_and_tall':
            height = 735;
    }
    return height + 'px';
};

function popup_window(loc, width, height, resizable, scrollbars, toolbar, dependent, window_name, location_bar, status_bar, align) {
    var left_position = 1;
    var top_position = 1;

    if (align === "center") {
        left_position = screen.width ? (screen.width - width) / 2 : 0;
        top_position = screen.height ? (screen.height - height) / 2 : 0;
    } else if (align === "topright") {
        left_position = screen.width ? screen.width - width : 0;
        top_position = 1;
    } else if (align === "topcenter") {
        left_position = screen.width ? (screen.width - width) / 2 : 0;
        top_position = 1;
    }

    var align_value = 'top=' + top_position + ',left=' + left_position;
    var win = eval("window.open(loc, '${window_name}','width=${width},height=${height},resizable=${resizable},scrollbars=" + scrollbars + ",toolbar=" + toolbar + ",dependent=" + dependent + ",screenX=1,screenY=1,${align_value},location=${location_bar},status=${status_bar}')");
    win.focus();
};

function configure_selectboxes() {
    function toggle_unselected_style(target) {
        var _selectbox = $(target);
        if (!_selectbox || _selectbox.val() === '' || !_selectbox.val()) {
            $(_selectbox).addClass('unselected');
        } else {
            $(_selectbox).removeClass('unselected');
        }
    };

    var selectboxes = $('.select-holder select');
    selectboxes.each(function (index, selectbox) {
        toggle_unselected_style(selectbox);

        $(selectbox).change(function (e) {
            toggle_unselected_style(e.currentTarget);
        });
    });
};

var Popup = function () {
    _createClass(Popup, [{
        key: 'defaults',
        get: function get() {
            return {
                version: 2,
                cookie: 'pm1',
                expires: 7,
                delay: 1000,
                content: null,
                width: 760,
                height: 460
            };
        }
    }]);

    function Popup(options) {
        _classCallCheck(this, Popup);

        this.options = $.extend({}, this.defaults, options);
        this.$content = null;
    }

    _createClass(Popup, [{
        key: 'fire',
        value: function fire() {
            // optionally fire if the cookie is missing
            if (this.options.cookie) {
                var v = window.evite.cookie(this.options.cookie);
                if (v == null || v !== this.options.version + '') {
                    setTimeout(this.show, this.options.delay);
                    window.evite.cookie(this.options.cookie, this.options.version, {
                        expires: this.options.expires
                    });
                }
            }
            return this;
        }
    }, {
        key: 'remove',
        value: function remove() {
            if (this.$content) {
                this.$content.detach();
                this.$content = null;
            }
            $("body").unbind('click', this.remove);
            return this;
        }
    }, {
        key: 'render',
        value: function render() {
            // no spaces in this block
            var overlay = $('<div class="interstitial-overlay" style="filter: alpha(opacity=50)"></div>');
            var container = $('<div class="interstitial"></div>');
            var call = $('<div class="call"><img src="/assets/images/modal/close.png" class="close-popup"></div>');
            call.appendTo(container);
            call.css({
                width: this.options.width,
                height: this.options.height
            });
            $(this.options.content).appendTo(call);
            return [overlay, container, call];
        }
    }, {
        key: 'show',
        value: function show() {
            var _this8 = this;

            var r = this.render();
            var overlay = r[0];
            this.$content = r[1];
            var call = r[2];
            overlay.appendTo($('body'));
            this.$content.appendTo($('body'));

            overlay.fadeIn(this.options.delay);
            call.fadeIn(this.options.delay);

            $("body").click(function () {
                if (_this8.$content) {
                    _this8.$content.fadeOut(200, _this8.remove);
                    return overlay.fadeOut(200, _this8.remove);
                }
            });

            return this;
        }
    }]);

    return Popup;
}();

;

var PartnerIntegration = function (_Backbone$Model2) {
    _inherits(PartnerIntegration, _Backbone$Model2);

    function PartnerIntegration() {
        _classCallCheck(this, PartnerIntegration);

        return _possibleConstructorReturn(this, (PartnerIntegration.__proto__ || Object.getPrototypeOf(PartnerIntegration)).apply(this, arguments));
    }

    _createClass(PartnerIntegration, [{
        key: 'initialize',
        value: function initialize() {
            var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.save = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(this.defaults)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var k = _step.value;

                    var passed = values[k] || getURLParameter(k);
                    this.set(k, passed);
                    if (k !== 'event_type' && passed) {
                        this.save = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.save) {
                store.set("partner_ev", this.attributes, {
                    TTL: 600000
                });
            }
        }
    }, {
        key: 'fetch',
        value: function fetch() {
            var data;
            data = store.get("partner_ev");
            store.remove("partner_ev");
            return data;
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                event_type: null,
                nm: null,
                add: null,
                ct: null,
                st: null,
                zip: null,
                sdt: null,
                edt: null,
                tz: null,
                hn: null,
                et: null,
                ph: null,
                mess: null,
                mess_link: null
            };
        }
    }]);

    return PartnerIntegration;
}(Backbone.Model);

;

var partner_data = window.partner_data;
if (!partner_data) {
    partner_data = {};
}
window.partner_integration = new PartnerIntegration(partner_data);
window.RegisterLogin = _registerLogin2.default;

$(document).ready(function () {
    (0, _ajax_csrf_setup.ajax_csrf_setup)();
    if (window.is_modal === true) {
        // don't want to do this stuff in a modal
        return;
    }
    window.sign_in_model = new SignInModel();
    window.sign_in_view = new SignInView();
    window.header_nav_view = new HeaderNavView();
    window.Popup = Popup;

    window.card_height = card_height;
    window.popup_window = popup_window;
    if (window.is_mobile_site && !window.is_card) {
        window.menu_padding = 52; // allow space for top menu/nav bar on mobile
    } else {
        window.menu_padding = 0;
    }

    if (window.browserBlast != null) {
        window.browserBlast({
            devMode: false,
            supportedIE: '11',
            message: 'You are using an old version of Internet Explorer that is not supported by Evite. Please <a href="http://browsehappy.com" target="_blank">upgrade</a> for the best experience.'
        });
    }

    if (store && !window.location.hash && window.location.protocol !== 'https:') {
        if (store.get('cookie-warning', 0) === 0) {
            store.set('cookie-warning', 1);
            $(document).ready(function () {
                $('#cookie-warning').slideDown('fast', function () {
                    $('#cookie-warning').removeClass("hidden").removeAttr("style");
                    $('#header_spacer').height($('#header').height() + window.menu_padding);
                    $(window).scroll();
                    if (window.is_mobile_site) {
                        var navElem = $("#event_view_tabs");
                        if (navElem) {
                            // move down the event view tab bar by the height of the cookie warning div
                            var currTop = navElem.offset().top;
                            var warningHeight = $('#cookie-warning').outerHeight();
                            navElem.offset({ top: currTop + warningHeight });
                        }
                    }
                });
            });
        }
    }

    $('#cookie-warning a.close').click(function () {
        $('#cookie-warning').hide();
        window.cookie_dismissed = true;
        $('#header_spacer').height($('#header').height() + window.menu_padding);
    });

    if (window.pm_popup_options != null) {
        window.pm_popup = new Popup(window.pm_popup_options).fire();
    }

    if ('ontouchstart' in document.documentElement) {
        var $body = $('body');
        $(document).on('focus', 'input,textarea', function () {
            $body.addClass('fixFixed');
        }).on('blur', 'input,textarea', function () {
            $body.removeClass('fixFixed');
        });
    }

    $("#header_spacer").outerHeight($("#header").outerHeight() + window.menu_padding);

    configure_selectboxes();
});

exports.ajax_csrf_setup = _ajax_csrf_setup.ajax_csrf_setup;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)))

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegisterLogin = function (_Backbone$View) {
    _inherits(RegisterLogin, _Backbone$View);

    function RegisterLogin() {
        _classCallCheck(this, RegisterLogin);

        return _possibleConstructorReturn(this, (RegisterLogin.__proto__ || Object.getPrototypeOf(RegisterLogin)).apply(this, arguments));
    }

    _createClass(RegisterLogin, [{
        key: 'initialize',
        value: function initialize() {
            this.submitting = false;
            $('#id_email').focus();
        }
    }, {
        key: 'submit_handler',
        value: function submit_handler(e) {
            if (this.submitting) {
                e.preventDefault();
                return;
            }

            this.submitting = true;

            this.submit_form();
        }
    }, {
        key: 'facebook_connect',
        value: function facebook_connect(e) {
            e.preventDefault();

            window.sign_in_view.facebook_connect({
                onConnect: function onConnect() {
                    var next = getURLParameter('next');
                    if (next) {
                        window.parent.location = next;
                    } else {
                        window.location = '/';
                    }
                }
            });
        }
    }, {
        key: 'google_plus_connect',
        value: function google_plus_connect(e) {
            e.preventDefault();

            window.sign_in_view.google_plus_connect({
                onConnect: function onConnect() {
                    var next = getURLParameter('next');
                    if (next) {
                        window.parent.location = next;
                    } else {
                        window.location = '/';
                    }
                }
            });
        }
    }, {
        key: 'forgot_password',
        value: function forgot_password() {
            window.forgot_modal = new SecureModal({
                url: urls.get('forgot_modal'),
                onOpen: function onOpen(iframe) {
                    return iframe.find('#id_email').val($('#id_email').val());
                }
            });
            window.forgot_modal.show();
        }
    }, {
        key: 'toggle_password',
        value: function toggle_password(e) {
            e.preventDefault();
            $('#passwords').toggleClass('shown');
            var pwType = $('#id_password').closest('#passwords').hasClass('shown') ? 'text' : 'password';
            $('#id_password').attr("type", pwType);
            return false;
        }
    }, {
        key: 'el',
        get: function get() {
            return 'body';
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'form submit': 'submit_handler',
                'click button.register': 'submit_handler',
                'click #facebook_account_auth': 'facebook_connect',
                'click #google_plus_account_auth': 'google_plus_connect',
                'click #forgot_password': 'forgot_password',
                'tap #toggle_password': 'toggle_password',
                'click #toggle_password': 'toggle_password'
            };
        }
    }, {
        key: 'submit_form',
        get: function get() {
            var _this2 = this;

            return _.debounce(function () {
                return _this2.submitting = false;
            }, 1000);
        }
    }]);

    return RegisterLogin;
}(Backbone.View);

;

exports.default = RegisterLogin;

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ajax_csrf_setup = undefined;

var _evite = __webpack_require__(60);

var _evite2 = _interopRequireDefault(_evite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ajax_csrf_setup() {
    var csrfSafeMethod = function csrfSafeMethod(method) {
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
        );
    };
    var csrf_token = (0, _evite2.default)('csrftoken');
    $.ajaxSetup({
        beforeSend: function beforeSend(xhr, settings) {
            if (!csrfSafeMethod(settings.type)) {
                return xhr.setRequestHeader("X-CSRFToken", csrf_token);
            }
        }
    });
}

exports.ajax_csrf_setup = ajax_csrf_setup;

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pluralize = pluralize;
function pluralize(label, count) {
  label = count === 1 ? label : label + "s";
  return count + " " + label;
}

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileAppPageView = function (_Backbone$View) {
    _inherits(MobileAppPageView, _Backbone$View);

    function MobileAppPageView() {
        _classCallCheck(this, MobileAppPageView);

        return _possibleConstructorReturn(this, (MobileAppPageView.__proto__ || Object.getPrototypeOf(MobileAppPageView)).apply(this, arguments));
    }

    _createClass(MobileAppPageView, [{
        key: 'initialize',
        value: function initialize() {
            var $navs = $('.app-nav');
            var currentUrl = this.getParameterByName('app');
            var $currentLink = $('.app-nav[data-id=' + currentUrl + ']');
            var $contentToDisplay = $('.app-wrap[id=' + currentUrl + ']');
            var left = $contentToDisplay.find('.left').get(0);
            var right = $contentToDisplay.find('.right').get(0);

            if (typeof window.is_mobile_site !== 'undefined' && window.is_mobile_site) {
                this.$el.removeClass('side-menu-active');
            } else {
                $navs.removeClass('selected');
                $currentLink.addClass('selected');
            }
            $('.app-wrap').addClass('closed');
            $($contentToDisplay).removeClass('closed');

            this.$el.find('.mobile-marketing').on('swipeleft', function () {
                if (right) {
                    window.location.href = right;
                }
            });
            this.$el.find('.mobile-marketing').on('swiperight', function () {
                if (left) {
                    window.location.href = left;
                }
            });
        }
    }, {
        key: 'getParameterByName',
        value: function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);

            if (!results || !results[2]) {
                return 'evite-app';
            }

            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    }, {
        key: 'el',
        get: function get() {
            return 'body';
        }
    }]);

    return MobileAppPageView;
}(Backbone.View);

$(document).ready(function () {
    new MobileAppPageView();
});

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(XDate) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeSinceUTCDate = undefined;

var _utils = __webpack_require__(245);

/*
    Given a UTC timestamp for a time in the past,
    return a human-readable label describing how long ago that was.
 */
function getTimeSinceUTCDate(utc_timestamp) {
  var diffMinutes = utc_timestamp.diffMinutes(XDate());

  var i = Math.floor(diffMinutes / 8640); // 6 days
  if (i >= 1) return utc_timestamp.toString("MMMM d, yyyy");
  i = Math.floor(diffMinutes / 1440); // Days
  if (i >= 1) return (0, _utils.pluralize)("day", i) + " ago";
  i = Math.floor(diffMinutes / 60); // Hours
  if (i >= 1) return (0, _utils.pluralize)("hour", i) + " ago";
  i = Math.floor(diffMinutes); // Minutes
  if (i >= 1) return (0, _utils.pluralize)("minute", i) + " ago";
  return 'just now';
}

exports.getTimeSinceUTCDate = getTimeSinceUTCDate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(XDate) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _timestamp = __webpack_require__(319);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOTIFICATION_ITEM_CLASS = "notification-item";

function ajax_notify_update(ids_to_update, attr, attrvalue, success_callback) {
    var error_callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    var url = urls.get('ajax_notify_update');
    var payload = { "messages": ids_to_update };
    payload[attr] = attrvalue;
    $.ajax({
        url: url,
        method: "POST",
        type: "POST",
        timeout: 10000,
        data: payload,
        // The following options broke this method altogether.
        //data: JSON.stringify(payload),
        //processData: false,
        //contentType: false,
        success: success_callback,
        error: function error(jqXHR, textStatus, errorThrown) {
            window.console.log("Error while posting to " + url + ": textStatus=" + textStatus + " errorThrown=" + errorThrown);
            if (error_callback) {
                error_callback();
            }
        }
    });
}

function _mapunion(map0, map1) {
    var m = {},
        map = null,
        key = null;
    var _arr = [map0, map1];
    for (var _i = 0; _i < _arr.length; _i++) {
        map = _arr[_i];

        for (key in map) {
            m[key] = map[key];
        }
    }
    return m;
}

var Notification = function (_Backbone$Model) {
    _inherits(Notification, _Backbone$Model);

    function Notification() {
        _classCallCheck(this, Notification);

        return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
    }

    _createClass(Notification, [{
        key: "destroy",
        value: function destroy() {
            var id_to_delete = this.get("created");
            var that = this;
            ajax_notify_update(id_to_delete, "delete", true, function (data, textStatus, jqXHR) {
                that.trigger("notification:hide", id_to_delete);
            });
        }
    }, {
        key: "idAttribute",
        get: function get() {
            return "created";
        }
    }, {
        key: "created_as_date",
        get: function get() {
            var CREATED_REGEX = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.(\d{3})/;
            var match = CREATED_REGEX.exec(this.get("created"));
            var d = new XDate();
            if (match) {
                d.setUTCFullYear(match[1], parseInt(match[2], 10) - 1, match[3]);
                d.setUTCHours(match[4], match[5], match[6], match[7]);
            }
            return d;
        }
    }]);

    return Notification;
}(Backbone.Model);

var Notifications = function (_Backbone$Collection) {
    _inherits(Notifications, _Backbone$Collection);

    function Notifications() {
        _classCallCheck(this, Notifications);

        return _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).apply(this, arguments));
    }

    _createClass(Notifications, [{
        key: "markAllAs",
        value: function markAllAs(attr) {
            var ids_to_update = this.get_not_attr(attr);
            var that = this;
            ajax_notify_update(ids_to_update.toString(), attr, true, function (data, textStatus, jqXHR) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = ids_to_update[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var id = _step.value;

                        that.get(id).set(attr, true);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }, {
        key: "parse",
        value: function parse(response) {
            return response.notifications;
        }

        /*
        count_not_attr('viewed', '') returns 5 if there are 5 unviewed messages,
        or an empty string if there are 0 unviewed messages.
        */

    }, {
        key: "count_not_attr",
        value: function count_not_attr(attr, zerovalue) {
            var count = this.get_not_attr(attr).length;
            return count ? count : zerovalue;
        }

        // get_not_attr('viewed') returns the ID's (i.e., unique creation timestamps) of unviewed messages

    }, {
        key: "get_not_attr",
        value: function get_not_attr(attr) {
            var ids = [];
            this.reduce(function (idarray, n) {
                if (!n.get(attr)) {
                    idarray.push(n.get("created"));
                }
                return idarray;
            }, ids);
            return ids;
        }
    }, {
        key: "model",
        get: function get() {
            return Notification;
        }
    }, {
        key: "url",
        get: function get() {
            return urls.get('ajax_notify_items');
        }
    }, {
        key: "unviewed",
        get: function get() {
            return this.count_not_attr('viewed', '');
        }
    }, {
        key: "unread",
        get: function get() {
            return this.count_not_attr('read', '');
        }
    }]);

    return Notifications;
}(Backbone.Collection);

var NotificationsBadgeView = function (_Backbone$View) {
    _inherits(NotificationsBadgeView, _Backbone$View);

    function NotificationsBadgeView() {
        _classCallCheck(this, NotificationsBadgeView);

        return _possibleConstructorReturn(this, (NotificationsBadgeView.__proto__ || Object.getPrototypeOf(NotificationsBadgeView)).apply(this, arguments));
    }

    _createClass(NotificationsBadgeView, [{
        key: "initialize",
        value: function initialize() {
            var _arr2 = ['change', 'remove', 'sync'];

            for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
                var event = _arr2[_i2];
                this.listenTo(this.model, event, this.render);
            }
            this.template = _.template('<%= unviewed %>');
        }
    }, {
        key: "render",
        value: function render() {
            this.$el.html(this.template(this.model));
            if (this.model.unviewed) {
                this.$el.parent().addClass("badged");
            } else {
                this.$el.parent().removeClass("badged");
            }
            return this;
        }
    }]);

    return NotificationsBadgeView;
}(Backbone.View);

var NotificationView = function (_Backbone$View2) {
    _inherits(NotificationView, _Backbone$View2);

    function NotificationView() {
        _classCallCheck(this, NotificationView);

        return _possibleConstructorReturn(this, (NotificationView.__proto__ || Object.getPrototypeOf(NotificationView)).apply(this, arguments));
    }

    _createClass(NotificationView, [{
        key: "_avatar",
        value: function _avatar() {
            var m = this.model;
            var avatar_element = m.get("re_user_initials");
            var re_user_image_url = m.get("re_user_image_url");
            var re_user_avatar_disk = m.get("re_user_avatar_disk");
            if (re_user_image_url) {
                avatar_element = "<img class=\"profile-image\" src=\"" + re_user_image_url + "\"/>";
            }
            return "<div class=\"photo\"><div class=\"avatar avatar-" + re_user_avatar_disk + " small\">" + avatar_element + "</div></div>";
        }
    }, {
        key: "_event_settings_link",
        value: function _event_settings_link() {
            var m = this.model;
            if (!m.get("event_settings_url")) {
                return "";
            }
            return "<a class=\"ui-link\" href=\"" + m.get("event_settings_url") + "\">Adjust Notification settings for this event</a>";
        }
    }, {
        key: "_rendercontext",
        value: function _rendercontext() {
            var timestamp = (0, _timestamp.getTimeSinceUTCDate)(this.model.created_as_date);
            var read_bullet = "●";
            var switch_read_state = "read";
            if (this.model.get("read")) {
                read_bullet = "○";
                switch_read_state = "unread";
            }
            var extra = {
                "avatar": this._avatar(),
                "event_settings_link": this._event_settings_link(),
                "read_bullet": read_bullet,
                "switch_read_state": switch_read_state,
                "timestamp": timestamp
            };
            return _mapunion(this.model.attributes, extra);
        }
    }, {
        key: "initialize",
        value: function initialize(options) {
            this.options = options;
            this.parent_view = this.options.parent_view;
            this.listenTo(this.model, "change", this.render);
            this.context_controls_should_be_visible = false;
            this.discard_ie11_blurs = false;
        }
    }, {
        key: "render",
        value: function render() {
            var context = this._rendercontext();
            var html = this.template(context);
            this.$el.html(html);
            if (this.model.get("read")) {
                var element = this.$el.find('.' + NOTIFICATION_ITEM_CLASS);
                element.addClass('was-read');
            }
            if (this.context_controls_should_be_visible) {
                this.showContextControls();
            }
            return this;
        }
    }, {
        key: "selectContextMenuOnIE11",
        value: function selectContextMenuOnIE11(event) {
            // console.log('selectContextMenuOnIE11()');
            // console.log(event);
            this.selectContextMenu(event);
        }
    }, {
        key: "is_ie11",
        value: function is_ie11() {
            try {
                return $.browser.mozilla && $.browser.version == "11.0";
            } catch (TypeError) {
                return false;
            }
        }
    }, {
        key: "handleNotificationContextMenuBlurOnIE11",
        value: function handleNotificationContextMenuBlurOnIE11(event) {
            // console.log('handleNotificationContextMenuBlurOnIE11()');
            // console.log(event);
            if (event.target.className == "context-menu-icon") {
                // console.log('The blur happened for ' + tclass + '. Discarding.');
                return;
            }
            if (event.target.className == "hide-notification ui-link") {
                // console.log('Blur on the hide notification link means it was clicked.  Triggering...');
                this.hideNotification("Manual trigger");
            }
            if (event.target.className == 'ui-link') {
                // console.log('Blur on the event settings link means it was clicked. Triggering ' + event.target.href);
                this.discard_ie11_blurs = true; // We're going to a new page. Forget about doing more here.
                this.setNotificationAsReadThenNavigate(event);
            }
            if (this.discard_ie11_blurs) {
                // console.log("this.discard_ie11_blurs is true. Discarding the blur.");
                return;
            }
            // console.log('The blur happened for ' + event.target.className);
            this.hideContextMenu();
        }
    }, {
        key: "setNotificationAsReadThenNavigate",
        value: function setNotificationAsReadThenNavigate(event) {
            var linkurl = this.$el.find('.notification-text').attr('href');
            var follow_link = function follow_link() {
                window.location.assign(linkurl);
            };
            if (!this.model.get('read')) {
                this.toggleRead(follow_link);
            } else {
                follow_link();
            }
            if (event) {
                event.stopImmediatePropagation();
            }
        }
    }, {
        key: "toggleRead",
        value: function toggleRead() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var read_new = !this.model.get('read');
            var that = this;
            ajax_notify_update(this.model.get('created'), 'read', read_new, function () {
                that.model.set('read', read_new);
                if (callback) {
                    callback();
                }
            }, callback);
        }
    }, {
        key: "hideNotification",
        value: function hideNotification(event) {
            // console.log("hideNotification()");
            // console.log(event);
            this.model.destroy();
        }
    }, {
        key: "selectContextMenu",
        value: function selectContextMenu(event) {
            this.$el.find('.context-menu-items-wrapper').css('display', 'block');
            this.$el.find('.notification-context-menu').focus();
        }
    }, {
        key: "hideContextMenu",
        value: function hideContextMenu() {
            this.$el.find('.context-menu-items-wrapper').css('display', 'none');
        }
    }, {
        key: "showContextControls",
        value: function showContextControls() {
            var _arr3 = ['.bullet-with-tooltip', '.notification-context-menu'];

            for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
                var cselect = _arr3[_i3];
                this.$el.find(cselect).css('visibility', 'visible');
            }
            this.context_controls_should_be_visible = true;
        }
    }, {
        key: "hideContextControls",
        value: function hideContextControls() {
            this.hideContextMenu();
            var _arr4 = ['.bullet-with-tooltip', '.notification-context-menu'];
            for (var _i4 = 0; _i4 < _arr4.length; _i4++) {
                var cselect = _arr4[_i4];
                this.$el.find(cselect).css('visibility', 'hidden');
            }
            this.context_controls_should_be_visible = false;
        }
    }, {
        key: "template",
        get: function get() {
            var template_text = this.parent_view.notification_template;
            return _.template(template_text);
        }
    }, {
        key: "events",
        get: function get() {
            var evmap = {
                'click .hide-notification': 'hideNotification',
                'click .bullet-with-tooltip': 'toggleRead',
                'mouseenter .notification-item': 'showContextControls',
                'mouseleave .notification-item': 'hideContextControls'
            };

            // Special handling for IE11
            if (this.is_ie11()) {
                evmap['click .context-menu-icon'] = 'selectContextMenuOnIE11';
                evmap['blur .notification-context-menu'] = 'handleNotificationContextMenuBlurOnIE11';
            } else {
                evmap['click .context-menu-icon'] = 'selectContextMenu';
                evmap['click .notification-text'] = 'setNotificationAsReadThenNavigate';
                evmap['focusout .notification-context-menu'] = 'hideContextMenu';
            }
            return evmap;
        }
    }]);

    return NotificationView;
}(Backbone.View);

var SponsoredNotificationView = function (_Backbone$View3) {
    _inherits(SponsoredNotificationView, _Backbone$View3);

    function SponsoredNotificationView() {
        _classCallCheck(this, SponsoredNotificationView);

        return _possibleConstructorReturn(this, (SponsoredNotificationView.__proto__ || Object.getPrototypeOf(SponsoredNotificationView)).apply(this, arguments));
    }

    _createClass(SponsoredNotificationView, [{
        key: "initialize",
        value: function initialize(options) {
            this.options = options;
            this.parent_view = this.options.parent_view;
            this.listenTo(this.model, "change", this.render);
        }
    }, {
        key: "render",
        value: function render() {
            var html = this.template(this.model.attributes);
            this.$el.html(html);
            return this;
        }
    }, {
        key: "template",
        get: function get() {
            var template_text = this.parent_view.sponsored_notification_template;
            return _.template(template_text);
        }
    }]);

    return SponsoredNotificationView;
}(Backbone.View);

var NotificationCenterView = function (_Backbone$View4) {
    _inherits(NotificationCenterView, _Backbone$View4);

    function NotificationCenterView() {
        _classCallCheck(this, NotificationCenterView);

        return _possibleConstructorReturn(this, (NotificationCenterView.__proto__ || Object.getPrototypeOf(NotificationCenterView)).apply(this, arguments));
    }

    _createClass(NotificationCenterView, [{
        key: "handle_click",
        value: function handle_click() {
            if (this.options.nav_support) {
                var listelem = $(this.el).find('.notifications-list');
                var newvalue = listelem.css('display') == 'none' ? 'block' : 'none';
                listelem.css('display', newvalue);
            }
        }
    }, {
        key: "list_element_source",
        value: function list_element_source(selector) {
            var element = this.$el.find(selector)[0];
            var template_raw = element.innerHTML;
            // unquote expressions
            var template = template_raw.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            // If the element is wrapped in a script, just strip that outer element away and return it.
            if (element.localName == 'script') {
                return template;
            }
            // Don't show the element if it is empty.
            var className = element.className;
            if (!template) {
                className = 'do-not-show';
            }
            return '<' + element.localName + ' class="' + className + '">' + template + '</' + element.localName + '>';
        }
    }, {
        key: "initialize",
        value: function initialize(options) {
            this.options = options;
            var _arr5 = ['remove', 'sync'];
            for (var _i5 = 0; _i5 < _arr5.length; _i5++) {
                var event = _arr5[_i5];
                this.listenTo(this.model, event, this.render);
                this.listenTo(this.model, event, this.enable_or_disable_pulldown);
            }
            // If this is the view to show all notifications, reset the "viewed" state for all.
            if (this.options.viewing_all_notifications) {
                this.listenTo(this.model, 'sync', this.markAllAsViewed);
            }

            // Cache this element from the template for use later
            this.notifications_list_header = this.list_element_source('.notifications-list-header');
            this.notifications_list_footer = this.list_element_source('.notifications-list-footer');
            this.notification_template = this.list_element_source('.notification-item-wrapper');
            this.sponsored_notification_template = this.list_element_source('.sponsored-notification-item-wrapper');
            this.empty_notification_items_list = this.list_element_source('.empty-notification-items-list');
            this.page_size = this.options.items_per_page;
            this.page_index = 0;

            if (this.options.pulldown) {
                var that = this;
                this.options.pulldown.addPulldownClickCallback(function () {
                    that.markAllAsViewed();
                });
            }
        }
    }, {
        key: "notify_element_id",
        value: function notify_element_id(i) {
            var prefix = this.$el.attr("id");
            return prefix + "_notify_item_" + i;
        }
    }, {
        key: "enable_or_disable_pulldown",
        value: function enable_or_disable_pulldown() {
            if (this.options.pulldown) {
                // If we ever remove the "no notifications" default message in the Notification Center,
                // turn this back on.
                //this.options.pulldown.setEnabled(this.model.length > 0);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var list_element = this.$el.find('.notifications-list');
            var tagName = "li";

            // Create empty list items, one for each notification.
            list_element.html(this.notifications_list_header + this.notifications_list_footer);
            var starting_index = this.page_size * this.page_index;
            var ending_index = Math.min(this.model.length, this.page_size * (1 + this.page_index));
            for (var i = starting_index; i < ending_index; ++i) {
                var item = "<" + tagName + " id=\"" + this.notify_element_id(i) + "\"></" + tagName + ">";
                this.$el.find('.notifications-list>li:last-child').before(item);
            }

            // Create a view for each Notification.
            var has_sponsored = false;
            for (var i = starting_index; i < ending_index; ++i) {
                var model = this.model.at(i);
                var el = this.$el.find(tagName + "#" + this.notify_element_id(i));
                var view_options = {
                    el: el,
                    model: model,
                    id: this.notify_element_id(),
                    parent_view: this
                };
                if (model.get("msg_type") == "sponsored") {
                    model.view = new SponsoredNotificationView(view_options);
                    has_sponsored = true;
                } else {
                    model.view = new NotificationView(view_options);
                }
                model.trigger("change");
                this.listenTo(model, "notification:hide", this.hideNotification);
            }

            if (ending_index == 0 || has_sponsored && ending_index == 1) {
                var _item = this.empty_notification_items_list;
                this.$el.find('.notifications-list>li:last-child').before(_item);
            }

            return this;
        }
    }, {
        key: "markAllAsViewed",
        value: function markAllAsViewed() {
            if (this.model.unviewed > 0) {
                this.model.markAllAs("viewed");
            }
        }
    }, {
        key: "markAllAsRead",
        value: function markAllAsRead() {
            this.model.markAllAs("read");
        }
    }, {
        key: "hideNotification",
        value: function hideNotification(created) {
            this.model.remove(created);
        }
    }, {
        key: "events",
        get: function get() {
            return {
                "click .notifications-mark-all-as-read": "markAllAsRead"
            };
        }
    }]);

    return NotificationCenterView;
}(Backbone.View);

var PulldownMenu = function (_Backbone$View5) {
    _inherits(PulldownMenu, _Backbone$View5);

    function PulldownMenu() {
        _classCallCheck(this, PulldownMenu);

        return _possibleConstructorReturn(this, (PulldownMenu.__proto__ || Object.getPrototypeOf(PulldownMenu)).apply(this, arguments));
    }

    _createClass(PulldownMenu, [{
        key: "initialize",
        value: function initialize(options) {
            this.options = options;
            this.hide_class = 'notifications-list-ornament-hidden';
            this.mouse_is_overhead = false;
            this.enabled = true;
            this.pulldown_click_callback = null;
        }
    }, {
        key: "menuIsHidden",
        value: function menuIsHidden() {
            return this.ornament.hasClass(this.hide_class);
        }
    }, {
        key: "hideMenu",
        value: function hideMenu() {
            this.ornament.addClass(this.hide_class);
            this.menu.css('display', 'none');
        }
    }, {
        key: "showMenu",
        value: function showMenu() {
            if (this.enabled) {
                this.ornament.removeClass(this.hide_class);
                this.menu.css('display', 'block');
            }
        }
    }, {
        key: "addPulldownClickCallback",
        value: function addPulldownClickCallback(callback) {
            this.pulldown_click_callback = callback;
        }
    }, {
        key: "onPulldownClick",
        value: function onPulldownClick() {
            this.toggleMenu();
            if (this.pulldown_click_callback) {
                this.pulldown_click_callback();
            }
        }
    }, {
        key: "toggleMenu",
        value: function toggleMenu() {
            if (this.menuIsHidden()) {
                this.showMenu();
            } else {
                this.hideMenu();
            }
        }
    }, {
        key: "handleFocusout",
        value: function handleFocusout(event) {
            //console.log(event);
            if (!this.mouse_is_overhead) {
                //console.log("Hide menu after focusout:");
                this.hideMenu();
            }
        }
    }, {
        key: "handleMouseenter",
        value: function handleMouseenter(event) {
            if (!this.mouse_is_overhead) {
                //console.log("On mouseenter, mouse_is_overhead is switching to true.");
            }
            this.mouse_is_overhead = true;
        }
    }, {
        key: "handleMouseleave",
        value: function handleMouseleave(event) {
            if (this.mouse_is_overhead) {
                //console.log("On mouseleave, mouse_is_overhead is switching to false.");
            }
            this.mouse_is_overhead = false;
            this.$el.find('a.pulldown-link').focus();
        }
    }, {
        key: "setEnabled",
        value: function setEnabled(e) {
            this.enabled = e;
            if (!e) {
                this.hideMenu();
            }
        }
    }, {
        key: "events",
        get: function get() {
            return {
                "click a.pulldown-link": "onPulldownClick",
                "focusout": "handleFocusout",
                "mouseenter": "handleMouseenter",
                "mouseleave": "handleMouseleave"
            };
        }
    }, {
        key: "menu",
        get: function get() {
            return this.$el.find('ul.menu');
        }
    }, {
        key: "ornament",
        get: function get() {
            return this.$el.find('.notifications-list-ornament');
        }
    }]);

    return PulldownMenu;
}(Backbone.View);

$(document).ready(function () {
    // none of this applies if the user is not logged in, let's save ourselves some browser time
    if (!window.client_data.is_logged_in) return;

    var notifications = new Notifications();
    var viewing_all_notifications = false;
    var nav_support = true;
    var nav_center_pulldown = null;

    $('.unviewed-count').each(function () {
        new NotificationsBadgeView({
            el: this,
            model: notifications
        });
    });

    $('li.account-more').each(function () {
        var pulldown = new PulldownMenu({
            el: this
        });
        if (this.id == "nav_nctr") {
            nav_center_pulldown = pulldown;
        }
    });

    $('.notification-center').each(function () {
        var items_per_page = window.NOTIFICATION_CENTER_NAVBAR_LIMIT; // nav bar view
        var pulldown = null;
        if (this.id == "nav_nctr") {
            pulldown = nav_center_pulldown;
        } else {
            viewing_all_notifications = true;
            nav_support = false;
            items_per_page = window.NOTIFICATION_CENTER_PER_USER_LIMIT;
        }
        if (items_per_page > 0) {
            var notification_center_view = new NotificationCenterView({
                el: this,
                model: notifications,
                items_per_page: items_per_page,
                pulldown: pulldown,
                nav_support: nav_support,
                viewing_all_notifications: viewing_all_notifications
            });
        }
    });

    notifications.fetch();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -------------------------------------------------------
// --------------------- Side menu -----------------------
// -------------------------------------------------------
var MenuSlide = function (_Backbone$View) {
    _inherits(MenuSlide, _Backbone$View);

    function MenuSlide() {
        _classCallCheck(this, MenuSlide);

        return _possibleConstructorReturn(this, (MenuSlide.__proto__ || Object.getPrototypeOf(MenuSlide)).apply(this, arguments));
    }

    _createClass(MenuSlide, [{
        key: 'toggle_menu',
        value: function toggle_menu() {
            this.$el.toggleClass('side-menu-active');
        }
    }, {
        key: 'close_menu',
        value: function close_menu() {
            this.$el.removeClass('side-menu-active');
        }
    }, {
        key: 'close_menu_prevent_default',
        value: function close_menu_prevent_default(e) {
            e.preventDefault();

            this.close_menu();
        }
    }, {
        key: 'el',
        get: function get() {
            return 'body';
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click #start_create_button': 'toggle_menu',
                'click .button-nav.menu': 'toggle_menu',
                'click .register-signin': 'close_menu',
                'swipeleft #side_menu': 'close_menu',
                'tap .content-mask': 'close_menu_prevent_default',
                'click .content-mask': 'close_menu_prevent_default',
                'swipeleft .content-mask': 'close_menu'
            };
        }
    }]);

    return MenuSlide;
}(Backbone.View);

;

var NavAccordionToggle = function (_Backbone$View2) {
    _inherits(NavAccordionToggle, _Backbone$View2);

    function NavAccordionToggle() {
        _classCallCheck(this, NavAccordionToggle);

        return _possibleConstructorReturn(this, (NavAccordionToggle.__proto__ || Object.getPrototypeOf(NavAccordionToggle)).apply(this, arguments));
    }

    _createClass(NavAccordionToggle, [{
        key: 'toggle_accordion',
        value: function toggle_accordion(e) {
            e.preventDefault();
            var header = $(e.target).closest('.accordion-nav');
            var currentActive = $('.ui-accordion').not('.collapsed');

            if (header.parent('div').hasClass('collapsed')) {
                $(currentActive).children('ul').slideUp('fast', function () {
                    $(currentActive).children('.accordion-nav').addClass('inactive');
                    $(currentActive).addClass('collapsed');
                });
                $(header.parent('div').children('ul')).slideDown('fast', function () {
                    header.parent('div').removeClass('collapsed');
                    header.removeClass('inactive');
                });
            };
        }
    }, {
        key: 'el',
        get: function get() {
            return '.accordion-nav';
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click': 'toggle_accordion'
            };
        }
    }]);

    return NavAccordionToggle;
}(Backbone.View);

;

$(function () {
    window.menu_slide = new MenuSlide();
    window.nav_accordion_toggle = new NavAccordionToggle();
});

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleCarousel = function (_Backbone$View) {
    _inherits(SimpleCarousel, _Backbone$View);

    function SimpleCarousel() {
        _classCallCheck(this, SimpleCarousel);

        return _possibleConstructorReturn(this, (SimpleCarousel.__proto__ || Object.getPrototypeOf(SimpleCarousel)).apply(this, arguments));
    }

    _createClass(SimpleCarousel, [{
        key: 'initialize',
        value: function initialize() {
            this._init_carousel();
            if (this.total_width > this.frame_width) {
                return this._activate();
            }
        }
    }, {
        key: '_init_carousel',
        value: function _init_carousel() {
            this.inner = $(this.el).find('.inner > ul');
            this.frame_width = $(this.el).width();
            this.total_width = this._get_total_width();
            this.current_scroll = 0;

            this._scroll_carousel(0);
        }
    }, {
        key: '_activate',
        value: function _activate() {
            var _this2 = this;

            $(this.el).find('.inner').append('<div class="previous disabled"><i class="icon-arrow-left"></i></div>').append('<div class="next"><i class="icon-arrow-right"></i></div>');

            $(window).resize(function () {
                if (_this2.frame_width !== $(_this2.el).width()) {
                    _this2._init_carousel();
                }
            });
        }
    }, {
        key: '_handle_next_slide',
        value: function _handle_next_slide(e) {
            e.preventDefault();

            if (-this.current_scroll + this.frame_width < this.total_width) {
                this._scroll_carousel(-this.frame_width);
            }
        }
    }, {
        key: '_handle_previous_slide',
        value: function _handle_previous_slide(e) {
            e.preventDefault();

            if (-this.current_scroll - this.frame_width >= 0) {
                this._scroll_carousel(this.frame_width);
            }
        }
    }, {
        key: '_scroll_carousel',
        value: function _scroll_carousel(distance) {
            this.current_scroll += distance;
            this.inner.animate({
                marginLeft: this.current_scroll
            }, 400);
            this._update_controls_ui();
            this._pause_videos();
        }
    }, {
        key: '_update_controls_ui',
        value: function _update_controls_ui() {
            $(this.el).find('.previous, .next').addClass('disabled');
            // buffer to prevent extra slide on iphone due to padding inconsistencies
            if (-this.current_scroll + this.frame_width < this.total_width - 5) {
                $(this.el).find('.next').removeClass('disabled');
            }
            if (-this.current_scroll - this.frame_width >= 0) {
                $(this.el).find('.previous').removeClass('disabled');
            }
        }
    }, {
        key: '_pause_videos',
        value: function _pause_videos() {
            $('video').each(function () {
                this.pause();
            });
        }
    }, {
        key: '_get_total_width',
        value: function _get_total_width() {
            var w = 0;
            this.inner.find('> li').each(function () {
                w += $(this).outerWidth();
            });
            return w;
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click .next': '_handle_next_slide',
                'click .previous': '_handle_previous_slide'
            };
        }
    }]);

    return SimpleCarousel;
}(Backbone.View);

;

$(function () {
    $('.simple-carousel').each(function () {
        new SimpleCarousel({
            el: this
        });
    });
});

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.modal_ajax_error_handler = modal_ajax_error_handler;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalView = function (_Backbone$View) {
    _inherits(ModalView, _Backbone$View);

    function ModalView() {
        _classCallCheck(this, ModalView);

        return _possibleConstructorReturn(this, (ModalView.__proto__ || Object.getPrototypeOf(ModalView)).apply(this, arguments));
    }

    _createClass(ModalView, [{
        key: 'initialize',
        value: function initialize(options) {
            var _this2 = this;

            this.mask = null;
            this.target = null;
            this.iframe = null;

            this.options = _.extend({}, this._base_defaults, options);
            if (this.options.closeOthers) {
                ModalView.close_all();
            }

            this.id = ModalView.last_id++;

            ModalView.views[this.id] = this;

            var body = $('body');

            this.$el.css({
                opacity: 0,
                background: '#ffffff',
                width: '100%',
                height: '100%',
                overflow: 'auto',
                '-webkit-overflow-scrolling': 'touch',
                '-webkit-transform': 'translateZ(2px)',
                '-moz-transform': 'translateZ(2px)',
                'transform': 'translateZ(2px)',
                display: 'none',
                position: 'fixed',
                top: '0',
                'z-index': 1200
            });

            // insert this new instance after existing dialogs to place above
            var dialogs = $('div.overlay-dialog');
            if (dialogs.length > 0) {
                this.$el.insertAfter($(dialogs[dialogs.length - 1]));
            } else {
                body.append(this.$el);
            }

            $(window).resize(function () {
                return _this2.resize();
            });
            return this;
        }
    }, {
        key: 'show',
        value: function show() {
            if (this.mask) {
                this.mask.fadeIn('fast');
            }
            this.$el.show();

            if (this.options.url) {
                this.render_iframe();
            } else if (this.options.target) {
                this.render_target();
            } else {
                throw 'modal error: no url or target specified';
            }

            return this;
        }
    }, {
        key: 'render_target',
        value: function render_target() {
            this.target = this.options.target;
            this.target.css({
                'z-index': 9999 + this.id
            }).appendTo(this.$el).show();
            this.$el.animate({
                opacity: '1'
            }, 200);
            return this.resize();
        }
    }, {
        key: 'make_frame',
        value: function make_frame() {
            return $('<iframe marginheight="0" marginwidth="0" frameborder="0" allowTransparency="true" name="modalframe">').css({
                width: "100%",
                height: "auto",
                maxHeight: window.screen && window.screen.height || window.innerHeight || docElement && docElement.clientHeight || docBody.clientHeight || 0,
                border: "none".css
            });
        }
    }, {
        key: '_query_string',
        value: function _query_string() {
            var params = {
                p: JSON.stringify(this.options.url_parameters),
                parent_url: document.location.href,
                parent_id: this.id
            };
            return '?' + $.param(params);
        }
    }, {
        key: 'navigate',
        value: function navigate(url) {
            var _this3 = this;

            // new url to be used as the parent_url in case of secure modals using postMessage
            this.options.url = url;

            // don't hide the frame or IE will refuse to measure the content, which
            // causes the modal to never display
            this.$el.fadeOut(200, function () {
                return _this3.$el.css({
                    opacity: 20
                });
            });

            this.iframe.attr('src', url + this._query_string()).load(function () {
                _this3.$el.fadeIn(200);
            });
        }
    }, {
        key: 'render_iframe',
        value: function render_iframe() {
            var _this4 = this;

            window.tags.page_event(this.options.url, 'open');
            this.$el.css({
                'z-index': 9999 + this.id
            });

            this.iframe = this.make_frame().attr('src', this.options.url + this._query_string());
            this.resize_on_show();
            this.iframe.appendTo(this.$el);
            this.iframe.load(function () {
                var e, win;
                win = _this4.iframe[0].contentWindow || _this4.iframe[0].contentDocument.defaultView;
                try {
                    return win.parent_id = _this4.id;
                } catch (error) {
                    // expected error for secure modals
                }
            });

            this.options.onLoad = function () {
                if (_this4.options.onOpen) {
                    return _this4.options.onOpen($(_this4.iframe.contents()));
                }
            };
            return this;
        }
    }, {
        key: 'resize_on_show',
        value: function resize_on_show() {
            var _this5 = this;

            return this.iframe.load(function () {
                if (_this5.options.onLoad != null) {
                    _this5.options.onLoad(_this5.iframe);
                }
                var try_resize = function try_resize() {
                    // the frame may not be loaded yet, so trying to measure content may fail
                    var e;
                    try {
                        if (_this5.iframe[0].contentWindow.document.body.offsetWidth === 0) {
                            setTimeout(try_resize, 100);
                        } else {
                            _this5.resize();
                        }
                    } catch (error) {
                        //  might get a permission denied... this is okay for secured iframes, they will use postMessage
                    }
                };
                setTimeout(try_resize, 100);
            });
        }
    }, {
        key: 'resize',
        value: function resize(height, width) {
            if (typeof height !== 'number') {
                height = parseInt(height, 10);
            }
            if (typeof width !== 'number') {
                width = parseInt(width, 10);
            }

            if (this.iframe) {
                if (!height || !width) {
                    try {
                        height = $(this.iframe[0].contentWindow.document.body).outerHeight();
                        width = $(this.iframe[0].contentWindow.document.body).offsetWidth();
                    } catch (error) {
                        // IE may raise exceptions on trying to access these too early
                    }
                }

                this.iframe.css({
                    width: '100%',
                    height: height + '50px'
                });

                this.$el.show().animate({
                    opacity: 100
                }, 100);
            }
            if (this.options.onShow) {
                this.options.onShow();
            }
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.options.onClose) {
                this.options.onClose();
            }
            if (this.mask) {
                this.mask.remove();
            }
            if (this.target) {
                this.target.hide();
            }
            if (this.iframe) {
                this.iframe.remove();
            }
            this.mask = null;
            this.target = null;
            this.iframe = null;
            this.$el.remove();
            ModalView.views[this.id] = void 0;
            $(".modal-hide").removeClass("modal-hide");
        }
    }, {
        key: 'respond',
        value: function respond(response) {
            window.tags.page_event(this.options.url, response.name);
            this.close();

            var name = response.name;
            var on_option = this.options['on' + name];
            if (on_option) {
                on_option(response);
            } else if (this.options.onResponse) {
                this.options.onResponse(response);
            }
        }
    }, {
        key: 'tagName',

        // A modal dialog utility that can be layered.

        get: function get() {
            return 'div';
        }
    }, {
        key: 'className',
        get: function get() {
            return 'overlay';
        }
    }, {
        key: '_base_defaults',
        get: function get() {
            return {
                buttons: ['Okay'],
                title: null,
                closeOnEsc: true,
                closeOthers: false,
                mask: {
                    color: '#ffffff',
                    loadSpeed: 1,
                    opacity: '1'
                },
                oneInstance: false,
                load: true,
                url_parameters: {}
            };
        }
    }], [{
        key: 'close_all',
        value: function close_all() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = ModalView.views[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var view = _step.value;

                    if (view && v.close != null) {
                        v.close();
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'post',
        value: function post(id, response) {
            var view = ModalView.views[id];
            if (view) {
                view.respond(response);
            }
        }
    }, {
        key: 'get_view',
        value: function get_view(id) {
            return ModalView.views[id];
        }
    }]);

    return ModalView;
}(Backbone.View);

;
ModalView.last_id = 1;
ModalView.views = {};

var SecureModal = function (_ModalView) {
    _inherits(SecureModal, _ModalView);

    function SecureModal() {
        _classCallCheck(this, SecureModal);

        return _possibleConstructorReturn(this, (SecureModal.__proto__ || Object.getPrototypeOf(SecureModal)).apply(this, arguments));
    }

    _createClass(SecureModal, [{
        key: 'initialize',
        value: function initialize() {
            // the url must have appended the parent's url in the hash to make messaging work
            this.options.closeOthers = true;
            _get(SecureModal.prototype.__proto__ || Object.getPrototypeOf(SecureModal.prototype), 'initialize', this).apply(this, arguments);
            this.listen();
            return this;
        }
    }, {
        key: 'listen',
        value: function listen() {
            // setup a callback for the child window to tell us things
            $.receiveMessage(this.on_message);
        }
    }, {
        key: 'on_message',
        value: function on_message(e) {
            var _this7 = this;

            var data = $.parseParams(e.data);
            if (!data.action) {
                return;
            }

            if (data.action === 'resize') {
                this.resize(data.height, data.width);
            }

            if (data.action === 'close') {
                window.tags.page_event(this.options.url, 'close');
                this.close();
            }

            if (data.action === 'respond') {
                this.respond(data);
            }

            if (data.action === 'navigate') {
                this.navigate(data.url);
            }

            if (data.action === 'facebook_connect') {
                window.sign_in_view.facebook_connect({
                    onConnect: function onConnect() {
                        _this7.close();
                    }
                });
            }
            return true;
        }
    }, {
        key: 'resize_on_show',
        value: function resize_on_show(iframe, dialog) {
            // do nothing, the client window must post a message
        }
    }]);

    return SecureModal;
}(ModalView);

;

var LoadingModal = function (_ModalView2) {
    _inherits(LoadingModal, _ModalView2);

    function LoadingModal() {
        _classCallCheck(this, LoadingModal);

        return _possibleConstructorReturn(this, (LoadingModal.__proto__ || Object.getPrototypeOf(LoadingModal)).apply(this, arguments));
    }

    _createClass(LoadingModal, [{
        key: 'initialize',
        value: function initialize(options) {
            _get(LoadingModal.prototype.__proto__ || Object.getPrototypeOf(LoadingModal.prototype), 'initialize', this).apply(this, arguments);
            var div;
            // this.options = _.extend({}, this.defaults, options);
            div = $('\n            <div>\n                <div class="loader">Loading...</div>\n            </div>\n        ');
            div.css({
                background: 'white',
                width: '100%',
                height: '100%',
                border: '0',
                overflow: 'hidden'
            });
            div.find('.loader').css({
                padding: '90px 0',
                'font-size': '24px',
                'line-height': '50px',
                'background-position': '90px 92px',
                display: 'block',
                margin: '0',
                position: 'inherit'
            });
            this.options.target = div;
        }
    }, {
        key: 'show',
        value: function show(message) {
            this.options.target.find('.loader').html(message);
            return _get(LoadingModal.prototype.__proto__ || Object.getPrototypeOf(LoadingModal.prototype), 'show', this).apply(this, arguments);
        }
    }]);

    return LoadingModal;
}(ModalView);

;

// Example simple usage:
//
//  delete_modal = new ModalDialog
//    title:      'Delete Group'
//    body:       'Are you sure you wish to delete this group?'
//    buttons:    ['Cancel', 'Delete Group']
//    onResponse: (response) ->
//      if response.index == 1
//        console.log 'delete group'
//  delete_modal.show()

var ModalDialog = function (_ModalView3) {
    _inherits(ModalDialog, _ModalView3);

    function ModalDialog() {
        _classCallCheck(this, ModalDialog);

        return _possibleConstructorReturn(this, (ModalDialog.__proto__ || Object.getPrototypeOf(ModalDialog)).apply(this, arguments));
    }

    _createClass(ModalDialog, [{
        key: 'initialize',
        value: function initialize(options) {
            this.defaults.url = this.url;
            this.options = _.extend({}, this.defaults, options);
            this.options.url_parameters = this.options.url_parameters || {};
            this.options.url_parameters.dialog = {
                body: this.options.body,
                title: this.options.title,
                buttons: this.options.buttons,
                html: this.options.html
            };
            return _get(ModalDialog.prototype.__proto__ || Object.getPrototypeOf(ModalDialog.prototype), 'initialize', this).apply(this, arguments);
        }
    }, {
        key: 'url',
        get: function get() {
            return urls.get('modal_dialog');
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                buttons: ['Cancel', 'Yes'],
                title: null,
                html: false
            };
        }
    }]);

    return ModalDialog;
}(ModalView);

;

var ModalWarning = function (_ModalDialog) {
    _inherits(ModalWarning, _ModalDialog);

    function ModalWarning() {
        _classCallCheck(this, ModalWarning);

        return _possibleConstructorReturn(this, (ModalWarning.__proto__ || Object.getPrototypeOf(ModalWarning)).apply(this, arguments));
    }

    _createClass(ModalWarning, [{
        key: 'url',
        get: function get() {
            return urls.get('modal_warning');
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                buttons: ['Okay'],
                title: null
            };
        }
    }]);

    return ModalWarning;
}(ModalDialog);

;

var ModalAjaxError = function (_ModalDialog2) {
    _inherits(ModalAjaxError, _ModalDialog2);

    function ModalAjaxError() {
        _classCallCheck(this, ModalAjaxError);

        return _possibleConstructorReturn(this, (ModalAjaxError.__proto__ || Object.getPrototypeOf(ModalAjaxError)).apply(this, arguments));
    }

    _createClass(ModalAjaxError, [{
        key: 'url',

        // Report an ajax error to the user in a modal dialog

        get: function get() {
            return urls.get('modal_ajax_error');
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                buttons: ['Okay']
            };
        }
    }]);

    return ModalAjaxError;
}(ModalDialog);

;

var CaptchaDialog = function (_ModalView4) {
    _inherits(CaptchaDialog, _ModalView4);

    function CaptchaDialog() {
        _classCallCheck(this, CaptchaDialog);

        return _possibleConstructorReturn(this, (CaptchaDialog.__proto__ || Object.getPrototypeOf(CaptchaDialog)).apply(this, arguments));
    }

    _createClass(CaptchaDialog, [{
        key: 'initialize',
        value: function initialize(options) {
            this.options = _.extend({}, this.defaults, options);
            _get(CaptchaDialog.prototype.__proto__ || Object.getPrototypeOf(CaptchaDialog.prototype), 'initialize', this).apply(this, arguments);
            if (this.options.challenge.type === 'sms') {
                this.options.url = urls.get('sms_captcha');
            } else if (this.options.challenge.type === 'ad') {
                this.options.url = urls.get('ad_captcha');
            } else {
                this.options.url = urls.get('recaptcha');
            }
            if (this.options.challenge.captcha_event) {
                this.options.url = this.options.url + this.options.challenge.captcha_event + '/';
                if (this.options.challenge.retry) {
                    this.options.url = this.options.url + 'retry/';
                }
            }
            this.options.url_parameters = {
                challenge: this.options.challenge
            };
        }
    }]);

    return CaptchaDialog;
}(ModalView);

;

var PopupModal = function (_ModalView5) {
    _inherits(PopupModal, _ModalView5);

    function PopupModal() {
        _classCallCheck(this, PopupModal);

        return _possibleConstructorReturn(this, (PopupModal.__proto__ || Object.getPrototypeOf(PopupModal)).apply(this, arguments));
    }

    _createClass(PopupModal, [{
        key: 'initialize',
        value: function initialize(options) {
            this.options = _.extend({}, this.defaults, options);
            _get(PopupModal.prototype.__proto__ || Object.getPrototypeOf(PopupModal.prototype), 'initialize', this).apply(this, arguments);
            if (!this.options.body) {
                throw '"body" is required';
            }
            if (!this.options.title) {
                throw '"title" is required';
            }
            if (!this.options.buttons) {
                throw '"buttons" is required';
            }
            var div = $('\n            <div class=\'popup-modal\'>\n                <div class="modal-header">\n                    <h1></h1>\n                </div>\n                <div class="modal-body">\n                    <div class="wrapper">\n                        <p></p>\n                    </div>\n                </div>\n                <div class="modal-footer"></div>\n            </div>\n        ');
            div.css({
                background: 'white',
                width: this.options.width || '100%',
                height: '100%',
                'min-height': '250px',
                overflow: 'scroll',
                border: '1px solid #ddd',
                position: 'fixed'
            });
            this.options.target = div;
        }
    }, {
        key: 'show',
        value: function show() {
            var body = this.options.body;
            var title = this.options.title;
            var buttons = this.options.buttons;
            this.options.target.find('.modal-header h1').html(title);
            this.options.target.find('.modal-body p').html(body);

            var button_markup = '';
            var key = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = buttons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var button = _step2.value;

                    if (buttons.length === 1 * key + 1) {
                        button_markup += '<a class="button-primary" data-name="' + button + '" data-index="' + key + '">' + button + '</a>';
                    } else {
                        button_markup += '<a class="button-primary-inverse" data-name="' + button + '" data-index="' + key + '">' + button + '</a>';
                    }
                    ++key;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.options.target.find('.modal-footer').html(button_markup);
            _get(PopupModal.prototype.__proto__ || Object.getPrototypeOf(PopupModal.prototype), 'show', this).call(this);
            this.respond(this.options, buttons);
            return this;
        }
    }, {
        key: 'respond',
        value: function respond(options) {
            var key = 0;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = options.buttons[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var button = _step3.value;

                    $(options.target.find('.modal-footer a')[key]).on('click', this.options.onResponse);
                    ++key;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'close_div',
        value: function close_div() {
            return this.close();
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click .close_window a': 'close_div'
            };
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                buttons: ['Cancel', 'Yes'],
                title: null
            };
        }
    }]);

    return PopupModal;
}(ModalView);

;

function modal_ajax_error_handler(xhr, status, errorstr) {
    var body = 'Sorry, an error has occurred';

    try {
        var message = JSON.parse(xhr.responseText).message;
        if (message) {
            body = message;
        }
    } catch (error) {}

    new ModalAjaxError({
        title: 'Error',
        body: body,
        url_parameters: {
            response: xhr.responseText,
            status: status,
            error: errorstr
        }
    }).show();
};

window.CaptchaDialog = CaptchaDialog;
window.ModalView = ModalView;
window.SecureModal = SecureModal;
window.ModalDialog = ModalDialog;
window.PopupModal = PopupModal;
window.LoadingModal = LoadingModal;
window.ModalWarning = ModalWarning;
window.ModalAjaxError = ModalAjaxError;

$(document).ready(function () {
    // close the topmost dialog on escape (if the options allow it)
    $(document).bind('keyup', function (e) {
        if (e.keyCode !== 27) {
            return;
        }

        for (var id = ModalView.last_id; id >= 0; --id) {
            var _v = ModalView.views[id];
            if (_v && _v.close != null) {
                if (_v.options.closeOnEsc) {
                    _v.close();
                }
                break;
            }
        }
        this.close();
    });
});

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {
    $('#profile_page a.signin').click(function () {
        window.sign_in_view.sign_in();
    });

    $('#profile_page a.register').click(function () {
        window.sign_in_view.register();
    });
});

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cookie;
/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

/**
 * Create a cookie with the given name and value and other optional parameters.
 *
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Set the value of a cookie.
 * @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
 * @desc Create a cookie with all available options.
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Create a session cookie.
 * @example $.cookie('the_cookie', null);
 * @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
 *       used when the cookie was set.
 *
 * @param String name The name of the cookie.
 * @param String value The value of the cookie.
 * @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
 * @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
 *                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
 *                             If set to null or omitted, the cookie will be a session cookie and will not be retained
 *                             when the the browser exits.
 * @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
 * @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
 * @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
 *                        require a secure protocol (like HTTPS).
 * @type undefined
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */

/**
 * Get the value of a cookie with the given name.
 *
 * @example $.cookie('the_cookie');
 * @desc Get the value of a cookie.
 *
 * @param String name The name of the cookie.
 * @return The value of the cookie.
 * @type String
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */
function cookie(name, value, options) {
    if (typeof value != 'undefined') {
        // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // CAUTION: Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + options.path : '';
        var domain = options.domain ? '; domain=' + options.domain : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else {
        // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == name + '=') {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

window.evite = window.evite || {};
window.evite.cookie = cookie;

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(189);
__webpack_require__(228);
__webpack_require__(377);
__webpack_require__(281);
__webpack_require__(401);
__webpack_require__(378);
__webpack_require__(404);
module.exports = __webpack_require__(376);


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @preserve XDate v@VERSION
 * Docs & Licensing: http://arshaw.com/xdate/
 */

/*
 * Internal Architecture
 * ---------------------
 * An XDate wraps a native Date. The native Date is stored in the '0' property of the object.
 * UTC-mode is determined by whether the internal native Date's toString method is set to
 * Date.prototype.toUTCString (see getUTCMode).
 *
 */

var XDate = (function(Date, Math, Array, undefined) {


/** @const */ var FULLYEAR     = 0;
/** @const */ var MONTH        = 1;
/** @const */ var DATE         = 2;
/** @const */ var HOURS        = 3;
/** @const */ var MINUTES      = 4;
/** @const */ var SECONDS      = 5;
/** @const */ var MILLISECONDS = 6;
/** @const */ var DAY          = 7;
/** @const */ var YEAR         = 8;
/** @const */ var WEEK         = 9;
/** @const */ var DAY_MS = 86400000;
var ISO_FORMAT_STRING = "yyyy-MM-dd'T'HH:mm:ss(.fff)";
var ISO_FORMAT_STRING_TZ = ISO_FORMAT_STRING + "zzz";


var methodSubjects = [
	'FullYear',     // 0
	'Month',        // 1
	'Date',         // 2
	'Hours',        // 3
	'Minutes',      // 4
	'Seconds',      // 5
	'Milliseconds', // 6
	'Day',          // 7
	'Year'          // 8
];
var subjectPlurals = [
	'Years',        // 0
	'Months',       // 1
	'Days'          // 2
];
var unitsWithin = [
	12,   // months in year
	31,   // days in month (sort of)
	24,   // hours in day
	60,   // minutes in hour
	60,   // seconds in minute
	1000, // milliseconds in second
	1     //
];
var formatStringRE = new RegExp(
	"(([a-zA-Z])\\2*)|" + // 1, 2
	"(\\(" + "(('.*?'|\\(.*?\\)|.)*?)" + "\\))|" + // 3, 4, 5 (allows for 1 level of inner quotes or parens)
	"('(.*?)')" // 6, 7
);
var UTC = Date.UTC;
var toUTCString = Date.prototype.toUTCString;
var proto = XDate.prototype;



// This makes an XDate look pretty in Firebug and Web Inspector.
// It makes an XDate seem array-like, and displays [ <internal-date>.toString() ]
proto.length = 1;
proto.splice = Array.prototype.splice;




/* Constructor
---------------------------------------------------------------------------------*/

// TODO: in future, I'd change signature for the constructor regarding the `true` utc-mode param. ~ashaw
//   I'd move the boolean to be the *first* argument. Still optional. Seems cleaner.
//   I'd remove it from the `xdate`, `nativeDate`, and `milliseconds` constructors.
//      (because you can simply call .setUTCMode(true) after)
//   And I'd only leave it for the y/m/d/h/m/s/m and `dateString` constructors
//      (because those are the only constructors that need it for DST-gap data-loss reasons)
//   Should do this for 1.0

function XDate() {
	return init(
		(this instanceof XDate) ? this : new XDate(),
		arguments
	);
}


function init(xdate, args) {
	var len = args.length;
	var utcMode;
	if (isBoolean(args[len-1])) {
		utcMode = args[--len];
		args = slice(args, 0, len);
	}
	if (!len) {
		xdate[0] = new Date();
	}
	else if (len == 1) {
		var arg = args[0];
		if (arg instanceof Date || isNumber(arg)) {
			xdate[0] = new Date(+arg);
		}
		else if (arg instanceof XDate) {
			xdate[0] = _clone(arg);
		}
		else if (isString(arg)) {
			xdate[0] = new Date(0);
			xdate = parse(arg, utcMode || false, xdate);
		}
	}
	else {
		xdate[0] = new Date(UTC.apply(Date, args));
		if (!utcMode) {
			xdate[0] = coerceToLocal(xdate[0]);
		}
	}
	if (isBoolean(utcMode)) {
		setUTCMode(xdate, utcMode);
	}
	return xdate;
}



/* UTC Mode Methods
---------------------------------------------------------------------------------*/


proto.getUTCMode = methodize(getUTCMode);
function getUTCMode(xdate) {
	return xdate[0].toString === toUTCString;
};


proto.setUTCMode = methodize(setUTCMode);
function setUTCMode(xdate, utcMode, doCoercion) {
	if (utcMode) {
		if (!getUTCMode(xdate)) {
			if (doCoercion) {
				xdate[0] = coerceToUTC(xdate[0]);
			}
			xdate[0].toString = toUTCString;
		}
	}else{
		if (getUTCMode(xdate)) {
			if (doCoercion) {
				xdate[0] = coerceToLocal(xdate[0]);
			}else{
				xdate[0] = new Date(+xdate[0]);
			}
			// toString will have been cleared
		}
	}
	return xdate; // for chaining
}


proto.getTimezoneOffset = function() {
	if (getUTCMode(this)) {
		return 0;
	}else{
		return this[0].getTimezoneOffset();
	}
};



/* get / set / add / diff Methods (except for week-related)
---------------------------------------------------------------------------------*/


each(methodSubjects, function(subject, fieldIndex) {

	proto['get' + subject] = function() {
		return _getField(this[0], getUTCMode(this), fieldIndex);
	};
	
	if (fieldIndex != YEAR) { // because there is no getUTCYear
	
		proto['getUTC' + subject] = function() {
			return _getField(this[0], true, fieldIndex);
		};
		
	}

	if (fieldIndex != DAY) { // because there is no setDay or setUTCDay
	                         // and the add* and diff* methods use DATE instead
		
		proto['set' + subject] = function(value) {
			_set(this, fieldIndex, value, arguments, getUTCMode(this));
			return this; // for chaining
		};
		
		if (fieldIndex != YEAR) { // because there is no setUTCYear
		                          // and the add* and diff* methods use FULLYEAR instead
			
			proto['setUTC' + subject] = function(value) {
				_set(this, fieldIndex, value, arguments, true);
				return this; // for chaining
			};
			
			proto['add' + (subjectPlurals[fieldIndex] || subject)] = function(delta, preventOverflow) {
				_add(this, fieldIndex, delta, preventOverflow);
				return this; // for chaining
			};
			
			proto['diff' + (subjectPlurals[fieldIndex] || subject)] = function(otherDate) {
				return _diff(this, otherDate, fieldIndex);
			};
			
		}
		
	}

});


function _set(xdate, fieldIndex, value, args, useUTC) {
	var getField = curry(_getField, xdate[0], useUTC);
	var setField = curry(_setField, xdate[0], useUTC);
	var expectedMonth;
	var preventOverflow = false;
	if (args.length == 2 && isBoolean(args[1])) {
		preventOverflow = args[1];
		args = [ value ];
	}
	if (fieldIndex == MONTH) {
		expectedMonth = (value % 12 + 12) % 12;
	}else{
		expectedMonth = getField(MONTH);
	}
	setField(fieldIndex, args);
	if (preventOverflow && getField(MONTH) != expectedMonth) {
		setField(MONTH, [ getField(MONTH) - 1 ]);
		setField(DATE, [ getDaysInMonth(getField(FULLYEAR), getField(MONTH)) ]);
	}
}


function _add(xdate, fieldIndex, delta, preventOverflow) {
	delta = Number(delta);
	var intDelta = Math.floor(delta);
	xdate['set' + methodSubjects[fieldIndex]](
		xdate['get' + methodSubjects[fieldIndex]]() + intDelta,
		preventOverflow || false
	);
	if (intDelta != delta && fieldIndex < MILLISECONDS) {
		_add(xdate, fieldIndex+1, (delta-intDelta)*unitsWithin[fieldIndex], preventOverflow);
	}
}


function _diff(xdate1, xdate2, fieldIndex) { // fieldIndex=FULLYEAR is for years, fieldIndex=DATE is for days
	xdate1 = xdate1.clone().setUTCMode(true, true);
	xdate2 = XDate(xdate2).setUTCMode(true, true);
	var v = 0;
	if (fieldIndex == FULLYEAR || fieldIndex == MONTH) {
		for (var i=MILLISECONDS, methodName; i>=fieldIndex; i--) {
			v /= unitsWithin[i];
			v += _getField(xdate2, false, i) - _getField(xdate1, false, i);
		}
		if (fieldIndex == MONTH) {
			v += (xdate2.getFullYear() - xdate1.getFullYear()) * 12;
		}
	}
	else if (fieldIndex == DATE) {
		var clear1 = xdate1.toDate().setUTCHours(0, 0, 0, 0); // returns an ms value
		var clear2 = xdate2.toDate().setUTCHours(0, 0, 0, 0); // returns an ms value
		v = Math.round((clear2 - clear1) / DAY_MS) + ((xdate2 - clear2) - (xdate1 - clear1)) / DAY_MS;
	}
	else {
		v = (xdate2 - xdate1) / [
			3600000, // milliseconds in hour
			60000,   // milliseconds in minute
			1000,    // milliseconds in second
			1        //
			][fieldIndex - 3];
	}
	return v;
}



/* Week Methods
---------------------------------------------------------------------------------*/


proto.getWeek = function() {
	return _getWeek(curry(_getField, this, false));
};


proto.getUTCWeek = function() {
	return _getWeek(curry(_getField, this, true));
};


proto.setWeek = function(n, year) {
	_setWeek(this, n, year, false);
	return this; // for chaining
};


proto.setUTCWeek = function(n, year) {
	_setWeek(this, n, year, true);
	return this; // for chaining
};


proto.addWeeks = function(delta) {
	return this.addDays(Number(delta) * 7);
};


proto.diffWeeks = function(otherDate) {
	return _diff(this, otherDate, DATE) / 7;
};


function _getWeek(getField) {
	return getWeek(getField(FULLYEAR), getField(MONTH), getField(DATE));
}


function getWeek(year, month, date) {
	var d = new Date(UTC(year, month, date));
	var week1 = getWeek1(
		getWeekYear(year, month, date)
	);
	return Math.floor(Math.round((d - week1) / DAY_MS) / 7) + 1;
}


function getWeekYear(year, month, date) { // get the year that the date's week # belongs to
	var d = new Date(UTC(year, month, date));
	if (d < getWeek1(year)) {
		return year - 1;
	}
	else if (d >= getWeek1(year + 1)) {
		return year + 1;
	}
	return year;
}


function getWeek1(year) { // returns Date of first week of year, in UTC
	var d = new Date(UTC(year, 0, 4));
	d.setUTCDate(d.getUTCDate() - (d.getUTCDay() + 6) % 7); // make it Monday of the week
	return d;
}


function _setWeek(xdate, n, year, useUTC) {
	var getField = curry(_getField, xdate, useUTC);
	var setField = curry(_setField, xdate, useUTC);

	if (year === undefined) {
		year = getWeekYear(
			getField(FULLYEAR),
			getField(MONTH),
			getField(DATE)
		);
	}

	var week1 = getWeek1(year);
	if (!useUTC) {
		week1 = coerceToLocal(week1);
	}

	xdate.setTime(+week1);
	setField(DATE, [ getField(DATE) + (n-1) * 7 ]); // would have used xdate.addUTCWeeks :(
		// n-1 because n is 1-based
}



/* Parsing
---------------------------------------------------------------------------------*/


XDate.parsers = [
	parseISO
];


XDate.parse = function(str) {
	return +XDate(''+str);
};


function parse(str, utcMode, xdate) {
	var parsers = XDate.parsers;
	var i = 0;
	var res;
	for (; i<parsers.length; i++) {
		res = parsers[i](str, utcMode, xdate);
		if (res) {
			return res;
		}
	}
	xdate[0] = new Date(str);
	return xdate;
}


function parseISO(str, utcMode, xdate) {
	var m = str.match(/^(\d{4})(-(\d{2})(-(\d{2})([T ](\d{2}):(\d{2})(:(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/);
	if (m) {
		var d = new Date(UTC(
			m[1],
			m[3] ? m[3] - 1 : 0,
			m[5] || 1,
			m[7] || 0,
			m[8] || 0,
			m[10] || 0,
			m[12] ? Number('0.' + m[12]) * 1000 : 0
		));
		if (m[13]) { // has gmt offset or Z
			if (m[14]) { // has gmt offset
				d.setUTCMinutes(
					d.getUTCMinutes() +
					(m[15] == '-' ? 1 : -1) * (Number(m[16]) * 60 + (m[18] ? Number(m[18]) : 0))
				);
			}
		}else{ // no specified timezone
			if (!utcMode) {
				d = coerceToLocal(d);
			}
		}
		return xdate.setTime(+d);
	}
}



/* Formatting
---------------------------------------------------------------------------------*/


proto.toString = function(formatString, settings, uniqueness) {
	if (formatString === undefined || !valid(this)) {
		return this[0].toString(); // already accounts for utc-mode (might be toUTCString)
	}else{
		return format(this, formatString, settings, uniqueness, getUTCMode(this));
	}
};


proto.toUTCString = proto.toGMTString = function(formatString, settings, uniqueness) {
	if (formatString === undefined || !valid(this)) {
		return this[0].toUTCString();
	}else{
		return format(this, formatString, settings, uniqueness, true);
	}
};


proto.toISOString = function() {
	return this.toUTCString(ISO_FORMAT_STRING_TZ);
};


XDate.defaultLocale = '';
XDate.locales = {
	'': {
		monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
		dayNames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
		dayNamesShort: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
		amDesignator: 'AM',
		pmDesignator: 'PM'
	}
};
XDate.formatters = {
	i: ISO_FORMAT_STRING,
	u: ISO_FORMAT_STRING_TZ
};


function format(xdate, formatString, settings, uniqueness, useUTC) {

	var locales = XDate.locales;
	var defaultLocaleSettings = locales[XDate.defaultLocale] || {};
	var getField = curry(_getField, xdate, useUTC);
	
	settings = (isString(settings) ? locales[settings] : settings) || {};
	
	function getSetting(name) {
		return settings[name] || defaultLocaleSettings[name];
	}
	
	function getFieldAndTrace(fieldIndex) {
		if (uniqueness) {
			var i = (fieldIndex == DAY ? DATE : fieldIndex) - 1;
			for (; i>=0; i--) {
				uniqueness.push(getField(i));
			}
		}
		return getField(fieldIndex);
	}
	
	return _format(xdate, formatString, getFieldAndTrace, getSetting, useUTC);
}


function _format(xdate, formatString, getField, getSetting, useUTC) {
	var m;
	var subout;
	var out = '';
	while (m = formatString.match(formatStringRE)) {
		out += formatString.substr(0, m.index);
		if (m[1]) { // consecutive alphabetic characters
			out += processTokenString(xdate, m[1], getField, getSetting, useUTC);
		}
		else if (m[3]) { // parenthesis
			subout = _format(xdate, m[4], getField, getSetting, useUTC);
			if (parseInt(subout.replace(/\D/g, ''), 10)) { // if any of the numbers are non-zero. or no numbers at all
				out += subout;
			}
		}
		else { // else if (m[6]) { // single quotes
			out += m[7] || "'"; // if inner is blank, meaning 2 consecutive quotes = literal single quote
		}
		formatString = formatString.substr(m.index + m[0].length);
	}
	return out + formatString;
}


function processTokenString(xdate, tokenString, getField, getSetting, useUTC) {
	var end = tokenString.length;
	var replacement;
	var out = '';
	while (end > 0) {
		replacement = getTokenReplacement(xdate, tokenString.substr(0, end), getField, getSetting, useUTC);
		if (replacement !== undefined) {
			out += replacement;
			tokenString = tokenString.substr(end);
			end = tokenString.length;
		}else{
			end--;
		}
	}
	return out + tokenString;
}


function getTokenReplacement(xdate, token, getField, getSetting, useUTC) {
	var formatter = XDate.formatters[token];
	if (isString(formatter)) {
		return _format(xdate, formatter, getField, getSetting, useUTC);
	}
	else if (isFunction(formatter)) {
		return formatter(xdate, useUTC || false, getSetting);
	}
	switch (token) {
		case 'fff'  : return zeroPad(getField(MILLISECONDS), 3);
		case 's'    : return getField(SECONDS);
		case 'ss'   : return zeroPad(getField(SECONDS));
		case 'm'    : return getField(MINUTES);
		case 'mm'   : return zeroPad(getField(MINUTES));
		case 'h'    : return getField(HOURS) % 12 || 12;
		case 'hh'   : return zeroPad(getField(HOURS) % 12 || 12);
		case 'H'    : return getField(HOURS);
		case 'HH'   : return zeroPad(getField(HOURS));
		case 'd'    : return getField(DATE);
		case 'dd'   : return zeroPad(getField(DATE));
		case 'ddd'  : return getSetting('dayNamesShort')[getField(DAY)] || '';
		case 'dddd' : return getSetting('dayNames')[getField(DAY)] || '';
		case 'M'    : return getField(MONTH) + 1;
		case 'MM'   : return zeroPad(getField(MONTH) + 1);
		case 'MMM'  : return getSetting('monthNamesShort')[getField(MONTH)] || '';
		case 'MMMM' : return getSetting('monthNames')[getField(MONTH)] || '';
		case 'yy'   : return (getField(FULLYEAR)+'').substring(2);
		case 'yyyy' : return getField(FULLYEAR);
		case 't'    : return _getDesignator(getField, getSetting).substr(0, 1).toLowerCase();
		case 'tt'   : return _getDesignator(getField, getSetting).toLowerCase();
		case 'T'    : return _getDesignator(getField, getSetting).substr(0, 1);
		case 'TT'   : return _getDesignator(getField, getSetting);
		case 'z'    :
		case 'zz'   :
		case 'zzz'  : return useUTC ? 'Z' : _getTZString(xdate, token);
		case 'w'    : return _getWeek(getField);
		case 'ww'   : return zeroPad(_getWeek(getField));
		case 'S'    :
			var d = getField(DATE);
			if (d > 10 && d < 20) return 'th';
			return ['st', 'nd', 'rd'][d % 10 - 1] || 'th';
	}
}


function _getTZString(xdate, token) {
	var tzo = xdate.getTimezoneOffset();
	var sign = tzo < 0 ? '+' : '-';
	var hours = Math.floor(Math.abs(tzo) / 60);
	var minutes = Math.abs(tzo) % 60;
	var out = hours;
	if (token == 'zz') {
		out = zeroPad(hours);
	}
	else if (token == 'zzz') {
		out = zeroPad(hours) + ':' + zeroPad(minutes);
	}
	return sign + out;
}


function _getDesignator(getField, getSetting) {
	return getField(HOURS) < 12 ? getSetting('amDesignator') : getSetting('pmDesignator');
}



/* Misc Methods
---------------------------------------------------------------------------------*/


each(
	[ // other getters
		'getTime',
		'valueOf',
		'toDateString',
		'toTimeString',
		'toLocaleString',
		'toLocaleDateString',
		'toLocaleTimeString',
		'toJSON'
	],
	function(methodName) {
		proto[methodName] = function() {
			return this[0][methodName]();
		};
	}
);


proto.setTime = function(t) {
	this[0].setTime(t);
	return this; // for chaining
};


proto.valid = methodize(valid);
function valid(xdate) {
	return !isNaN(+xdate[0]);
}


proto.clone = function() {
	return new XDate(this);
};


proto.clearTime = function() {
	return this.setHours(0, 0, 0, 0); // will return an XDate for chaining
};


proto.toDate = function() {
	return new Date(+this[0]);
};



/* Misc Class Methods
---------------------------------------------------------------------------------*/


XDate.now = function() {
	return +new Date();
};


XDate.today = function() {
	return new XDate().clearTime();
};


XDate.UTC = UTC;


XDate.getDaysInMonth = getDaysInMonth;



/* Internal Utilities
---------------------------------------------------------------------------------*/


function _clone(xdate) { // returns the internal Date object that should be used
	var d = new Date(+xdate[0]);
	if (getUTCMode(xdate)) {
		d.toString = toUTCString;
	}
	return d;
}


function _getField(d, useUTC, fieldIndex) {
	return d['get' + (useUTC ? 'UTC' : '') + methodSubjects[fieldIndex]]();
}


function _setField(d, useUTC, fieldIndex, args) {
	d['set' + (useUTC ? 'UTC' : '') + methodSubjects[fieldIndex]].apply(d, args);
}



/* Date Math Utilities
---------------------------------------------------------------------------------*/


function coerceToUTC(date) {
	return new Date(UTC(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		date.getHours(),
		date.getMinutes(),
		date.getSeconds(),
		date.getMilliseconds()
	));
}


function coerceToLocal(date) {
	return new Date(
		date.getUTCFullYear(),
		date.getUTCMonth(),
		date.getUTCDate(),
		date.getUTCHours(),
		date.getUTCMinutes(),
		date.getUTCSeconds(),
		date.getUTCMilliseconds()
	);
}


function getDaysInMonth(year, month) {
	return 32 - new Date(UTC(year, month, 32)).getUTCDate();
}



/* General Utilities
---------------------------------------------------------------------------------*/


function methodize(f) {
	return function() {
		return f.apply(undefined, [this].concat(slice(arguments)));
	};
}


function curry(f) {
	var firstArgs = slice(arguments, 1);
	return function() {
		return f.apply(undefined, firstArgs.concat(slice(arguments)));
	};
}


function slice(a, start, end) {
	return Array.prototype.slice.call(
		a,
		start || 0, // start and end cannot be undefined for IE
		end===undefined ? a.length : end
	);
}


function each(a, f) {
	for (var i=0; i<a.length; i++) {
		f(a[i], i);
	};
}


function isString(arg) {
	return typeof arg == 'string';
}


function isNumber(arg) {
	return typeof arg == 'number';
}


function isBoolean(arg) {
	return typeof arg == 'boolean';
}


function isFunction(arg) {
	return typeof arg == 'function';
}


function zeroPad(n, len) {
	len = len || 2;
	n += '';
	while (n.length < len) {
		n = '0' + n;
	}
	return n;
}



// Export for Node.js
if (typeof module !== 'undefined' && module.exports) {
	module.exports = XDate;
}

// AMD
if (true) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return XDate;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


return XDate;

})(Date, Math, Array);


/***/ })

/******/ });


// WEBPACK FOOTER //
// mobile.base.main.js